var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExamplePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-196"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-196",
    cx: 251.29,
    cy: 339.05,
    rx: 239.98,
    ry: 138.55,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-196",
    d: "M291.23,388.74l53.47,30.85a3.77,3.77,0,0,0,3.4,0l75.09-43.19a1,1,0,0,0,0-2l-53.47-30.85a3.77,3.77,0,0,0-3.4,0l-75.09,43.19A1,1,0,0,0,291.23,388.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-196",
    d: "M429.58,395.4l-4.6-2.66a2.82,2.82,0,0,0-2.81,0l-52.71,30.89L364.91,429a.82.82,0,0,0,.83,1.33l10.49-2.78,53.35-30.8A.78.78,0,0,0,429.58,395.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-196",
    cx: 436.06,
    cy: 297.46,
    rx: 32.44,
    ry: 18.73,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-196",
    cx: 273.87,
    cy: 226.44,
    rx: 37.76,
    ry: 18.55,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-196",
    d: "M260,282.13l67.78,39.15a4.7,4.7,0,0,0,4.26,0l105.61-61a1.3,1.3,0,0,0,0-2.46L369.83,218.7a4.7,4.7,0,0,0-4.26,0L260,279.67A1.3,1.3,0,0,0,260,282.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-196",
    cx: 92.85,
    cy: 353.18,
    rx: 59.38,
    ry: 34.28,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-196",
    cx: 204.83,
    cy: 407.47,
    rx: 62.2,
    ry: 35.91,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70,321.41s1.14-17.55-5-32.43-16.4-25.33-27.2-28.17-21.49,5.65-11,14.69,30.05,19.87,35,47.5Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70,321.41s1.14-17.55-5-32.43-16.4-25.33-27.2-28.17-21.49,5.65-11,14.69,30.05,19.87,35,47.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,316.37l.12,0a.59.59,0,0,0,.46-.7c-6.44-30.58-26.32-46.45-35.94-50.56a.59.59,0,1,0-.46,1.09c9.41,4,28.9,19.61,35.24,49.71A.6.6,0,0,0,67.6,316.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.73,306.45c.49,2.1,2.41,3.5,4.22,4.67s3.77,2.41,4.48,4.44c1.43,4.09-3.06,8.61-1.46,12.63a6.72,6.72,0,0,0,4,3.47,44,44,0,0,0,4.35,1.25,17.48,17.48,0,0,0,2.14.23c2.09.1,4.31.42,6,1.82,2.62,2.2,2.81,6.07,4,9.26a14.16,14.16,0,0,0,8.69,8.08c3.24,1.07,8.36,1.28,9.49,0,.87-1-.43-4.73-.23-6a53.35,53.35,0,0,0,.63-10.1,18.65,18.65,0,0,1,.23-4.6c.33-1.69.66-3.39,1-5.09s1-3.2.74-5.17a19.31,19.31,0,0,0-2-5.37q-1.24-2.54-2.53-5A27,27,0,0,0,60,305.25a14.18,14.18,0,0,0-10.16-4.73c-3.19-.08-6.54,1.08-9.7.33s-5.94-2.14-9.15-2.53-7,.36-9.42,2.84A6,6,0,0,0,19.73,306.45Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.51,343.51h0A.48.48,0,0,0,65,343c-2.18-30.34-31.79-40.32-39-41.16a.48.48,0,1,0-.12,1c7.06.83,36,10.59,38.16,40.27A.48.48,0,0,0,64.51,343.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.51,322.44a.49.49,0,0,0,.28-.09,25.74,25.74,0,0,1,21.81-1.88.47.47,0,0,0,.61-.29.48.48,0,0,0-.29-.62,26.75,26.75,0,0,0-22.68,2,.48.48,0,0,0-.12.68A.51.51,0,0,0,33.51,322.44Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Microscope--inject-196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--microscope--inject-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356,89.86c-2.6-1.62-6.23-1.44-10.26.88a25.24,25.24,0,0,0-6.12,5.13c-.45.5-.89,1-1.3,1.57l-.07.08a34.56,34.56,0,0,0-5.37,10,25,25,0,0,0-1.38,7.87c0,4.43,1.52,7.57,4,9.1l4.74,2.74a7,7,0,0,1-1.92-1.76,12,12,0,0,1-2.06-7.34c0-9.07,6.37-20.11,14.23-24.65a11.93,11.93,0,0,1,7.43-1.86,6.71,6.71,0,0,1,2.74.93h0Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,89.86c-2.6-1.62-6.23-1.44-10.26.88a25.24,25.24,0,0,0-6.12,5.13c-.45.5-.89,1-1.3,1.57l-.07.08a34.56,34.56,0,0,0-5.37,10,25,25,0,0,0-1.38,7.87c0,4.43,1.52,7.57,4,9.1l4.74,2.74a7,7,0,0,1-1.92-1.76,12,12,0,0,1-2.06-7.34c0-9.07,6.37-20.11,14.23-24.65a11.93,11.93,0,0,1,7.43-1.86,6.71,6.71,0,0,1,2.74.93h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.65,92.55a6.71,6.71,0,0,0-2.74-.93,11.93,11.93,0,0,0-7.43,1.86c-7.86,4.54-14.23,15.58-14.23,24.65a12,12,0,0,0,2.06,7.34,7,7,0,0,0,1.92,1.76,1,1,0,0,0,.23.13,7.15,7.15,0,0,0,3.91.92,13,13,0,0,0,6.11-1.93c7.86-4.54,14.24-15.57,14.24-24.65C364.72,97.23,363.17,94.06,360.65,92.55Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.65,92.55a6.71,6.71,0,0,0-2.74-.93,11.93,11.93,0,0,0-7.43,1.86c-7.86,4.54-14.23,15.58-14.23,24.65a12,12,0,0,0,2.06,7.34,7,7,0,0,0,1.92,1.76,1,1,0,0,0,.23.13,7.15,7.15,0,0,0,3.91.92,13,13,0,0,0,6.11-1.93c7.86-4.54,14.24-15.57,14.24-24.65C364.72,97.23,363.17,94.06,360.65,92.55Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.15,247.6v8.21L329.77,316.08v-8.22c0-4.54,4.53-10.83,10.12-14.06L424,245.21c3.37-1.93,6.34-2.32,8.18-1.34A4,4,0,0,1,434.15,247.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,205.68l-.14-.08v0c-1.84-1.05-4.86-.69-8.28,1.29l-84.15,48.59c-5.58,3.22-10.11,9.52-10.11,14v8.22l66.42,38.35v-8.22c0-4.54,4.53-10.83,10.12-14.06L424,245.21c3.37-1.93,6.34-2.32,8.18-1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.02 286.42 324.02 275.46 286.06 253.55 286.06 264.5 324.02 286.42",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.02 286.42 324.02 275.46 286.06 253.55 286.06 264.5 324.02 286.42",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.02 286.42 352.48 269.98 352.48 259.02 324.02 275.46 324.02 286.42",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.02 286.42 352.48 269.98 352.48 259.02 324.02 275.46 324.02 286.42",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.06 253.55 314.53 237.11 352.48 259.02 324.02 275.46 286.06 253.55",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.41 251.7 314.53 244.7 336.13 257.18 324.02 264.17 302.41 251.7",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.41 251.7 302.41 253.55 324.02 266.02 324.02 264.17 302.41 251.7",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.13 257.18 324.02 264.17 324.02 266.02 336.13 259.02 336.13 257.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.12,222.84v13.69l-23.72,13.7v-13.7c0-7.55,5.32-16.76,11.87-20.54,3.32-1.92,6.31-2.08,8.46-.78S399.12,219.11,399.12,222.84Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.12,222.84v13.69l-23.72,13.7v-13.7c0-7.55,5.32-16.76,11.87-20.54,3.32-1.92,6.31-2.08,8.46-.78S399.12,219.11,399.12,222.84Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,198.82l-.18-.12c-2.14-1.21-5.1-1-8.36.85-6.55,3.79-11.86,13-11.86,20.55v13.7l28.46,16.43v-13.7c0-7.55,5.32-16.76,11.87-20.54,3.14-1.81,6-2.06,8.11-1Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,198.82l-.18-.12c-2.14-1.21-5.1-1-8.36.85-6.55,3.79-11.86,13-11.86,20.55v13.7l28.46,16.43v-13.7c0-7.55,5.32-16.76,11.87-20.54,3.14-1.81,6-2.06,8.11-1Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.26,224.93c2.62-1.51,4.75-.29,4.75,2.74a10.52,10.52,0,0,1-4.75,8.22c-2.62,1.51-4.74.28-4.74-2.74A10.48,10.48,0,0,1,387.26,224.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.92,130.94l7.2-12s-16.9-9.66-22.06-12.74l-7.19,12c7.62,4.55,12,15.57,12,30.22,0,17.23-5.9,36.62-15.46,54.26l22.06,12.74c9.56-17.64,15.46-37,15.46-54.26C397.93,146.5,393.55,135.49,385.92,130.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.92,130.94c7.63,4.55,12,15.57,12,30.22,0,17.23-5.91,36.62-15.46,54.26a16.61,16.61,0,0,1,1.78-1.18c3.31-1.92,6.3-2.07,8.45-.78.9.54,2.19,1.26,3,1.75a5.06,5.06,0,0,1,1.82,1.72c9.92-19,14.42-36.84,14.42-55.77,0-20.68-7.18-35.31-18.85-42.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.69,66l-5.52,7.56a3.69,3.69,0,0,1,1.94-1.2,6.55,6.55,0,0,1,2.47-.14,10.27,10.27,0,0,1,1.67.33,15.51,15.51,0,0,1,8.32,6.09,10.73,10.73,0,0,1,.81,1.48,6.87,6.87,0,0,1,.6,2.4,3.54,3.54,0,0,1-.65,2.34L399,77.2h0c.82-1.13.91-2.78.05-4.74a14.8,14.8,0,0,0-10.8-7.9C386.08,64.32,384.51,64.91,383.69,66Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.69,66l-5.52,7.56a3.69,3.69,0,0,1,1.94-1.2,6.55,6.55,0,0,1,2.47-.14,10.27,10.27,0,0,1,1.67.33,15.51,15.51,0,0,1,8.32,6.09,10.73,10.73,0,0,1,.81,1.48,6.87,6.87,0,0,1,.6,2.4,3.54,3.54,0,0,1-.65,2.34L399,77.2h0c.82-1.13.91-2.78.05-4.74a14.8,14.8,0,0,0-10.8-7.9C386.08,64.32,384.51,64.91,383.69,66Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.7,164.51a7.45,7.45,0,0,0,2.79-2.44l33.62-50.42L355.93,89.58l-37.84,47.27a7.38,7.38,0,0,0-1.5,3.46,11.33,11.33,0,0,0,.41,5.2,17.91,17.91,0,0,0,.84,2.29,22.29,22.29,0,0,0,1.74,3.21,34.91,34.91,0,0,0,19,13.89,22.19,22.19,0,0,0,3.6.7,19.34,19.34,0,0,0,2.81.1A11.35,11.35,0,0,0,349.7,164.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.16,159.56c1.62-2.46,1.68-6-.22-10.21-3.94-8.66-14.79-16.6-24.23-17.73-4.58-.54-8,.61-9.82,2.92l-6.23,7.83c-2.1,2.65-2.34,6.67-.35,11.32,3.86,9,14.92,17.11,24.69,18.06,5,.48,8.74-1,10.62-3.83Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,171.74c-9.78-1-20.85-9.05-24.73-18.09S314.18,138.07,324,139s20.85,9,24.72,18.09S347.77,172.7,338,171.74Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,171.74c-9.78-1-20.85-9.05-24.73-18.09S314.18,138.07,324,139s20.85,9,24.72,18.09S347.77,172.7,338,171.74Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.21,73.6l0,0-.05.06,0,0-6.5,9a28.53,28.53,0,0,1,15.27,11.16l6.49-9a3.58,3.58,0,0,0,.66-2.34,7.24,7.24,0,0,0-.61-2.41,10.18,10.18,0,0,0-.81-1.47,15.41,15.41,0,0,0-8.32-6.09,9,9,0,0,0-1.67-.34,6.77,6.77,0,0,0-2.47.14A3.66,3.66,0,0,0,378.21,73.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.68,151.39,306.6,167.8l20,14.65L338.71,166h0c1.08-1.48,1.18-3.67.06-6.23-2.26-5.12-8.6-9.76-14.17-10.36C321.82,149.14,319.76,149.91,318.68,151.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.63,182.45l-20-14.65,3.09-4.22c1.08-1.48,3.14-2.24,5.92-1.94,5.56.6,11.9,5.24,14.16,10.36,1.13,2.56,1,4.75-.06,6.23Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.71,184.39c-5.56-.6-11.9-5.24-14.16-10.36s.42-8.78,6-8.17,11.9,5.24,14.16,10.35S326.27,185,320.71,184.39Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.71,184.39c-5.56-.6-11.9-5.24-14.16-10.36s.42-8.78,6-8.17,11.9,5.24,14.16,10.35S326.27,185,320.71,184.39Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.65,179.73a9.61,9.61,0,0,1-7-5.15c-1.13-2.55.2-4.37,3-4.07a9.66,9.66,0,0,1,7.05,5.16C322.75,178.21,321.42,180,318.65,179.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371.03,
    cy: 100.62,
    r: 18.69,
    transform: "translate(-11.04 58.05) rotate(-8.81)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,102.53c-2.59-1.61-6.23-1.44-10.25.89a24.83,24.83,0,0,0-6.13,5.12c-.45.51-.88,1-1.29,1.57l-.07.08a34.32,34.32,0,0,0-5.37,10,25,25,0,0,0-1.38,7.87c0,4.43,1.52,7.57,4,9.1l4.74,2.75a7.1,7.1,0,0,1-1.91-1.77,12,12,0,0,1-2.07-7.33c0-9.08,6.38-20.12,14.24-24.66a11.93,11.93,0,0,1,7.43-1.86,6.58,6.58,0,0,1,2.73.94h0Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,102.53c-2.59-1.61-6.23-1.44-10.25.89a24.83,24.83,0,0,0-6.13,5.12c-.45.51-.88,1-1.29,1.57l-.07.08a34.32,34.32,0,0,0-5.37,10,25,25,0,0,0-1.38,7.87c0,4.43,1.52,7.57,4,9.1l4.74,2.75a7.1,7.1,0,0,1-1.91-1.77,12,12,0,0,1-2.07-7.33c0-9.08,6.38-20.12,14.24-24.66a11.93,11.93,0,0,1,7.43-1.86,6.58,6.58,0,0,1,2.73.94h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.77,105.23a6.58,6.58,0,0,0-2.73-.94,11.93,11.93,0,0,0-7.43,1.86c-7.86,4.54-14.24,15.58-14.24,24.66a12,12,0,0,0,2.07,7.33,7.1,7.1,0,0,0,1.91,1.77,1.34,1.34,0,0,0,.24.12,7.25,7.25,0,0,0,3.91.93,13.19,13.19,0,0,0,6.11-1.94c7.86-4.53,14.24-15.57,14.24-24.65C398.85,109.9,397.29,106.73,394.77,105.23Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.77,105.23a6.58,6.58,0,0,0-2.73-.94,11.93,11.93,0,0,0-7.43,1.86c-7.86,4.54-14.24,15.58-14.24,24.66a12,12,0,0,0,2.07,7.33,7.1,7.1,0,0,0,1.91,1.77,1.34,1.34,0,0,0,.24.12,7.25,7.25,0,0,0,3.91.93,13.19,13.19,0,0,0,6.11-1.94c7.86-4.53,14.24-15.57,14.24-24.65C398.85,109.9,397.29,106.73,394.77,105.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.61,116c3.16-1.83,5.73-.35,5.73,3.31a12.68,12.68,0,0,1-5.73,9.93c-3.17,1.83-5.74.35-5.74-3.31A12.67,12.67,0,0,1,384.61,116Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottle-2--inject-196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flask--inject-196"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 436.15,
    cy: 297.35,
    rx: 22.7,
    ry: 13.11,
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 436.15,
    cy: 297.35,
    rx: 22.7,
    ry: 13.11
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "446.05 239.36 446.04 207.4 426.25 207.44 426.24 239.36 446.05 239.36",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.15,
    cy: 272.64,
    r: 34.99,
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.13 239.36 444.78 209.94 443.35 210.39 443.35 239.36 444.13 239.36",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,213.51s-2,1.79-9.89,1.79-9.9-1.75-9.9-1.75v-6.11l19.79,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,208.75s-3.14,1.8-9.89,1.8-9.9-1.76-9.9-1.76v-1.35l19.79,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.74,201c-4.86-2-12.61-2-17.31,0s-4.7,5.1,0,7,12.45,1.94,17.31,0S449.6,202.91,444.74,201Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.25,204.66c.85.65,3.68,2.1,10.86,1.28,6.35-.73,5.47-3.93.37-4.3S429.25,204.66,429.25,204.66Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.71,201.92a23.87,23.87,0,0,0-11.21,0c-3.05.89-3.05,2.32,0,3.21a23.87,23.87,0,0,0,11.21,0C444.86,204.24,444.86,202.81,441.71,201.92Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.71,201.92a23.87,23.87,0,0,0-11.21,0c-3.05.89-3.05,2.32,0,3.21a23.87,23.87,0,0,0,11.21,0C444.86,204.24,444.86,202.81,441.71,201.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.74,208a6.91,6.91,0,0,0,3.19-2.21c-4.23,3.32-14.59,2.86-18.9,1.4s-4.43-4.35-2.73-5.69c-3.52,2-3.15,4.72,1.13,6.5C432.13,210,439.88,210,444.74,208Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.71,201.92a21.36,21.36,0,0,0-5.56-.66v4.53a21.36,21.36,0,0,0,5.56-.66C444.86,204.24,444.86,202.81,441.71,201.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.74,201a27,27,0,0,0-13.95-1c.46,0,9.21-1,13.8,1.37,4,2.06,3.82,3.89,2.76,5.1C449.32,204.64,448.46,202.45,444.74,201Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,272.64a30.87,30.87,0,1,1-61.74,0,30.51,30.51,0,0,1,2.53-12.25c1.22-2.9,3.79-5.65,7.71-7.9,11.39-6.58,29.86-6.58,41.26,0,3.92,2.25,6.48,5,7.71,7.9A30.85,30.85,0,0,1,467,272.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,272.64a30.9,30.9,0,0,0-2.47-12.11c-2.41,4.18-9.63,16.77-9.63,16.77,0,11.22-8.09,26.21-18.78,26.21A30.88,30.88,0,0,0,467,272.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.78,276.31c-11.4,6.58-29.87,6.58-41.26,0-7.48-4.32-10.06-10.4-7.71-15.92,1.22-2.9,3.79-5.65,7.71-7.9,11.39-6.58,29.86-6.58,41.26,0,3.92,2.25,6.48,5,7.71,7.9C466.83,265.91,464.25,272,456.78,276.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.88,271.07c-7.33-7.46-1.5-18,3.57-20.47a31.7,31.7,0,0,0-3.93,1.89c-3.92,2.25-6.49,5-7.71,7.9-2.35,5.52.23,11.6,7.71,15.92,9.64,5.57,24.36,6.4,35.57,2.54C438.43,280.76,423.1,278.41,415.88,271.07Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.92,243.64V209.47a24.35,24.35,0,0,1-6.67-.84v32.09a32.3,32.3,0,0,0-26,31.3c0,17.2,11.12,33.23,32.93,33.23C406.65,295.59,405.87,254.67,435.92,243.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "hard-light"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottle-1--inject-196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--flask--inject-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.51,217.5a8.45,8.45,0,0,0-1.59-4.83l-24.81-36.31V144.87l-18.48,0v31.45l-24.81,36.31a8.59,8.59,0,0,0-1.58,4.83c0,.08,0,.15,0,.23h0c0,.19,0,.37,0,.56a8,8,0,0,0,.12,1.29c.71,4.64,4.14,9.17,10.29,12.73,13.92,8,36.49,8,50.41,0,7-4,10.47-9.35,10.43-14.65C309.5,217.61,309.51,217.56,309.51,217.5Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.24,215.75l-6.45-9.43L289.6,192.7l-31.45,0L249,206.31l-6.45,9.44a4.78,4.78,0,0,0-.31,1.6,4.11,4.11,0,0,0,.18,1.35.19.19,0,0,0,0,.08c.76,3.72,3.79,7.33,9.07,10.18,12.37,6.68,32.44,6.68,44.82,0,5.26-2.84,8.29-6.44,9.07-10.14a.08.08,0,0,1,0,0,4.39,4.39,0,0,0,.19-1.49,0,0,0,0,0,0,0A5,5,0,0,0,305.24,215.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.6 147.66 281.93 147.24 281.81 177.13 297.21 201.21 280.6 177.5 280.6 147.66",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.11,150.57s-1.86,1.68-9.24,1.68-9.24-1.64-9.24-1.64v-5.7l18.48,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.11,146.13s-2.93,1.68-9.24,1.68-9.24-1.64-9.24-1.64v-1.26l18.48,0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.13,188.14c-5.75-.82-12.35-.3-16.84,1.56-6.25,2.59-6.25,6.79,0,9.37s16.55,2.59,23,0,6.46-6.78,0-9.37a27.43,27.43,0,0,0-6.17-1.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,138.85c-4.54-1.81-11.77-1.81-16.16,0s-4.39,4.77,0,6.59,11.62,1.81,16.16,0S286.43,140.67,281.89,138.85Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.43,142.31c.79.61,3.44,2,10.14,1.19,5.93-.68,5.11-3.67.35-4S267.43,142.31,267.43,142.31Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07,139.75a22.36,22.36,0,0,0-10.48,0c-2.84.83-2.84,2.17,0,3a22.36,22.36,0,0,0,10.48,0C282,141.92,282,140.58,279.07,139.75Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07,139.75a22.36,22.36,0,0,0-10.48,0c-2.84.83-2.84,2.17,0,3a22.36,22.36,0,0,0,10.48,0C282,141.92,282,140.58,279.07,139.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.31,198.09c-7.94,3.88-20.61,1.58-24.1-1.8s1.39-6.84,5.15-8.15a25.88,25.88,0,0,0-6.07,1.56c-6.25,2.59-6.25,6.79,0,9.37s16.55,2.59,23,0A13.45,13.45,0,0,0,287.31,198.09Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "hard-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,145.44a6.57,6.57,0,0,0,3-2.06c-3.95,3.09-13.63,2.67-17.65,1.3s-4.14-4.06-2.56-5.31c-3.28,1.82-2.94,4.41,1.06,6.07C270.12,147.25,277.35,147.25,281.89,145.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07,139.75a20.48,20.48,0,0,0-5.2-.62v4.24a20.48,20.48,0,0,0,5.2-.62C282,141.92,282,140.58,279.07,139.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.89,138.85a25.11,25.11,0,0,0-13-.9c.43,0,8.59-.92,12.89,1.28,3.74,1.92,3.56,3.63,2.58,4.76C286.17,142.29,285.36,140.24,281.89,138.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.56,179.48V146.61a19.71,19.71,0,0,1-4.05-.88V177.5l-25.05,36.58c-1.6,2.4-.45,5.86.89,8.68,1.12,2.34,4.72,5.42,7.18,6.86A39.8,39.8,0,0,0,264.43,235s-10.29-5.38-12.32-9.43c-1.52-3-.17-7.58,2-11.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      mixBlendMode: "hard-light"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--books--inject-196"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "300.01 385.06 347.79 412.5 416.18 373.01 368.4 345.57 300.01 385.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.22,410.84,301.78,384a15.44,15.44,0,0,0-.19-9.58l46.2,26.59S348.48,403.36,348.22,410.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.91,398.06a7.77,7.77,0,0,1,3.53,6.1v7.13c0,2.25-1.58,3.16-3.53,2L300,386.83v-1.77l45.42,26.09c1.16.68,2.11.13,2.11-1.22l0-6.61a4.69,4.69,0,0,0-2.12-3.66L300,373.56v-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,371.56l68.39-39.49,45.9,26.5a7.79,7.79,0,0,1,3.53,6.11v7.13a2.47,2.47,0,0,1-1,2.28l-68.4,39.49a2.5,2.5,0,0,0,1-2.28v-7.14a7.82,7.82,0,0,0-3.52-6.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.41,400.69a7.16,7.16,0,0,1,1,3.47v7.14a2.5,2.5,0,0,1-1,2.28l68.4-39.49a2.47,2.47,0,0,0,1-2.28v-7.13a7.31,7.31,0,0,0-1-3.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.54 366.32 353.48 390.4 416.31 354.13 378.28 332.31 311.54 366.32",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.54 366.32 353.48 390.4 416.31 354.13 378.28 332.31 311.54 366.32",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.92,388.74l-40.6-23.44a15.37,15.37,0,0,0-.2-9.58L353.48,379S354.18,381.26,353.92,388.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.92,388.74l-40.6-23.44a15.37,15.37,0,0,0-.2-9.58L353.48,379S354.18,381.26,353.92,388.74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.61,376a7.78,7.78,0,0,1,3.53,6.1v7.14c0,2.24-1.58,3.16-3.53,2l-40.06-23.14v-1.77l39.58,22.74c1.17.67,2.12.12,2.12-1.23l0-6.61a4.71,4.71,0,0,0-2.11-3.66l-39.54-22.74v-2Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.61,376a7.78,7.78,0,0,1,3.53,6.1v7.14c0,2.24-1.58,3.16-3.53,2l-40.06-23.14v-1.77l39.58,22.74c1.17.67,2.12.12,2.12-1.23l0-6.61a4.71,4.71,0,0,0-2.11-3.66l-39.54-22.74v-2Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.55,352.82l62.83-36.28,40.06,23.15a7.79,7.79,0,0,1,3.52,6.1v7.13a2.47,2.47,0,0,1-1,2.28L354.1,391.48a2.47,2.47,0,0,0,1-2.28v-7.14a7.78,7.78,0,0,0-3.53-6.1Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.11,378.59a7.16,7.16,0,0,1,1,3.47v7.14a2.47,2.47,0,0,1-1,2.28l62.83-36.28a2.47,2.47,0,0,0,1-2.28v-7.13a7.16,7.16,0,0,0-1-3.47Z",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.11,398.41l-.9.54-1.07.66-38.79,23.53c.32-.77,0-2.28-.8-3.72-.94-1.68-2.36-3-3.37-3L410.68,393l2.07-1.25C411.45,392.68,415.8,399.28,417.11,398.41Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.61,391.87c.57-.37,1.6.69,2.59,2,1.32,1.78,2.41,4.16,1.66,4.65l-1.47.9-.53.31c.75-.5-.34-2.88-1.66-4.66-1-1.29-2-2.27-2.61-2h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,392.83c1.32-.86,5.66,5.78,4.34,6.64l-2,1.21c1.32-.86-3-7.49-4.33-6.63Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.12,395.2l2-1.2c1.29-.85,5.54,5.52,4.46,6.57l-.07.06-2,1.19C412.78,400.94,408.43,394.33,407.12,395.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.18 416.4 372.18 416.4 372.18 416.4 372.19 416.4 372.18 416.4 366.33 423.36 366.33 423.36 372.18 416.4",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.33 423.36 364.92 425.05 366.33 423.36 366.33 423.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.32,418.14a4.19,4.19,0,0,0-3.13-1.74h0l-5.85,7a1.08,1.08,0,0,1,.63.33c.73.93.67,1.39.67,1.39l8.72-1.94C377.19,421.79,376.56,419.65,375.32,418.14Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,423.69a.82.82,0,0,0-.63-.33l-1.41,1.69h0a.33.33,0,0,0,0,.48.32.32,0,0,0,.3.08l2.38-.53S367.72,424.62,367,423.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,393.64l-7.85,4.78a.39.39,0,0,1-.14.05c.53-.64-.51-2.87-1.77-4.56-.92-1.24-2-2.2-2.59-2l8.19-5c1.79-1.3,4.24,2.08,4.76,4.52A2.05,2.05,0,0,1,425,393.64Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,393.64a2.05,2.05,0,0,0,.6-2.23l-.09-.35-48.89,29.52L365,425.53a.32.32,0,0,0,.3.08l2.38-.53,8.72-1.94h0Z",
    style: {
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--DNA--inject-196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--dna--inject-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.54,387.19a41.58,41.58,0,0,0-9.21-7.06c-21.82-12.6-57.19-12.6-79,0a41.58,41.58,0,0,0-9.21,7.06H149v15.74h0c0,8.26,5.45,16.51,16.36,22.81,21.81,12.59,57.19,12.59,79,0,10.91-6.3,16.36-14.55,16.36-22.81V387.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.83,
    cy: 389.93,
    rx: 55.86,
    ry: 32.25,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,359.15c14.67,0,28.43,3.29,38.76,9.25,10.08,5.82,15.63,13.47,15.63,21.53s-5.55,15.72-15.62,21.53c-10.34,6-24.1,9.25-38.77,9.25s-28.43-3.28-38.77-9.25C156,405.65,150.44,398,150.44,389.93s5.55-15.71,15.62-21.53c10.33-6,24.1-9.25,38.77-9.25m0-1.47c-14.3,0-28.59,3.15-39.5,9.45-21.82,12.59-21.82,33,0,45.61,10.91,6.3,25.2,9.45,39.5,9.45s28.59-3.15,39.5-9.45c21.82-12.6,21.82-33,0-45.61-10.91-6.3-25.2-9.45-39.5-9.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.17,372.76a34.57,34.57,0,0,0-7.63-5.84c-18.07-10.43-47.36-10.43-65.42,0a34.57,34.57,0,0,0-7.63,5.84h-5.92v13h0c0,6.84,4.52,13.67,13.55,18.89,18.06,10.43,47.36,10.43,65.42,0,9-5.22,13.55-12.05,13.55-18.89v-13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.83,
    cy: 375.17,
    rx: 45.52,
    ry: 26.28,
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.83,
    cy: 375.17,
    rx: 45.52,
    ry: 26.28,
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.83,349.94c12.1,0,23.46,2.7,32,7.62,8.27,4.77,12.82,11,12.82,17.61S245.07,388,236.8,392.78c-8.51,4.92-19.87,7.63-32,7.63s-23.46-2.71-32-7.63c-8.26-4.77-12.81-11-12.81-17.61s4.55-12.84,12.81-17.61c8.52-4.92,19.88-7.62,32-7.62m0-1.48c-11.84,0-23.68,2.61-32.71,7.83-18.07,10.43-18.07,27.34,0,37.77,9,5.21,20.87,7.82,32.71,7.82s23.68-2.61,32.71-7.82c18.07-10.43,18.07-27.34,0-37.77-9-5.22-20.87-7.83-32.71-7.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--dna--inject-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.45,345a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,197.45,345Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42,340.61a1,1,0,0,0-.66.74,1.06,1.06,0,0,0,.45.76A7.23,7.23,0,0,0,203,343.3a1.64,1.64,0,0,0,1.31.16,1.12,1.12,0,0,0,.61-1C205,340.7,202.76,340,201.42,340.61Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.69,346a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.54,3.54,0,0,1,201.69,346Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.07,347a4.7,4.7,0,0,1-3.4-5,4.47,4.47,0,0,0-.22,3,4.54,4.54,0,0,0,8.75,0,5.41,5.41,0,0,0,.12-.58C206,346,204.15,347.86,201.07,347Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.88,345.4a3.6,3.6,0,0,1,3.25.36,1.14,1.14,0,0,1,.57,1c0,.34-3.64,34.67-3.64,34.67l-4.6-.51s3.6-34.33,3.64-34.68A1.18,1.18,0,0,1,199.88,345.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,381.81a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,193.26,381.81Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,381.81a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,193.26,381.81Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.23,377.39a1,1,0,0,0-.66.74,1.09,1.09,0,0,0,.46.77,7.23,7.23,0,0,0,1.81,1.18,1.69,1.69,0,0,0,1.31.17,1.14,1.14,0,0,0,.61-1C200.77,377.49,198.57,376.83,197.23,377.39Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,382.81a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.53,3.53,0,0,1,197.5,382.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.88,383.79a4.69,4.69,0,0,1-3.39-5,4.48,4.48,0,0,0-.23,3.05,4.54,4.54,0,0,0,8.75,0,3.09,3.09,0,0,0,.12-.59C201.85,382.81,200,384.65,196.88,383.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,340.16a4.55,4.55,0,1,1,4.9-4.16A4.55,4.55,0,0,1,191.41,340.16Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,334.9a.93.93,0,0,0,.46.87,1,1,0,0,0,.88-.16,7.56,7.56,0,0,0,1.74-1.29,1.66,1.66,0,0,0,.6-1.17,1.1,1.1,0,0,0-.75-.93C189.94,331.62,188.57,333.45,188.64,334.9Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82,336.52a4.29,4.29,0,0,1-6.53-.24,4.54,4.54,0,1,0,6.62-4.66A3.54,3.54,0,0,1,193.82,336.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.52,337.44a4.69,4.69,0,0,1-5.89,1.45,4.47,4.47,0,0,0,2.78,1.27,4.55,4.55,0,0,0,3-8.23,4.33,4.33,0,0,0-.51-.31C195.32,332.44,196.39,334.84,194.52,337.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.25,338.05a3.64,3.64,0,0,1,2.9-1.52,1.15,1.15,0,0,1,1,.51l16.68,31.52-4.1,2.14-16.69-31.52A1.16,1.16,0,0,1,191.25,338.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,369.24a4.55,4.55,0,1,1,5.6,3.16A4.54,4.54,0,0,1,204.69,369.24Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,369.24a4.55,4.55,0,1,1,5.6,3.16A4.54,4.54,0,0,1,204.69,369.24Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,364.82a.94.94,0,0,0-.66.74,1.06,1.06,0,0,0,.45.76,7.82,7.82,0,0,0,1.82,1.19,1.63,1.63,0,0,0,1.3.16,1.11,1.11,0,0,0,.62-1C212.2,364.91,210,364.25,208.67,364.82Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.94,370.24a4.29,4.29,0,0,1-2-6.21,4.54,4.54,0,1,0,6.66,4.61A3.54,3.54,0,0,1,208.94,370.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.31,371.21a4.69,4.69,0,0,1-3.39-5,4.54,4.54,0,1,0,8.53,3c.05-.19.09-.39.12-.58C213.28,370.24,211.4,372.07,208.31,371.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,330.94a4.54,4.54,0,1,1,5.15,3.85A4.54,4.54,0,0,1,182.47,330.94Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,327.06a1,1,0,0,0-.75.65,1.08,1.08,0,0,0,.35.82,7.66,7.66,0,0,0,1.65,1.41,1.61,1.61,0,0,0,1.27.32,1.12,1.12,0,0,0,.75-.93C190.47,327.61,188.38,326.67,187,327.06Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.55,332.47a4.28,4.28,0,0,1-1.21-6.41,4.54,4.54,0,1,0,6,5.41A3.54,3.54,0,0,1,186.55,332.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,333.36a4.68,4.68,0,0,1-2.72-5.42,4.54,4.54,0,1,0,8.07,4.1,4.76,4.76,0,0,0,.19-.57C190.86,333,188.76,334.61,185.81,333.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,332.81a3.56,3.56,0,0,1,1.94-2.55,1.16,1.16,0,0,1,1.14,0c.27.2,28.49,23.33,28.49,23.33l-2.76,3.6-28.49-23.33A1.14,1.14,0,0,1,187.56,332.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.26,356.88a4.54,4.54,0,1,1,5.14,3.84A4.54,4.54,0,0,1,214.26,356.88Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.26,356.88a4.54,4.54,0,1,1,5.14,3.84A4.54,4.54,0,0,1,214.26,356.88Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,353c-.33.09-.69.3-.74.65a1.06,1.06,0,0,0,.35.81,7.17,7.17,0,0,0,1.65,1.41,1.66,1.66,0,0,0,1.27.33,1.13,1.13,0,0,0,.75-.94C222.26,353.54,220.16,352.61,218.76,353Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,358.41a4.28,4.28,0,0,1-1.21-6.42,4.54,4.54,0,1,0,6,5.42A3.54,3.54,0,0,1,218.34,358.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.6,359.3a4.7,4.7,0,0,1-2.73-5.42A4.54,4.54,0,1,0,223,358a5.27,5.27,0,0,0,.19-.56C222.65,359,220.55,360.54,217.6,359.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.37,279.5a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,212.37,279.5Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.37,279.5a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,212.37,279.5Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.34,275.08a1,1,0,0,0-.66.74,1.07,1.07,0,0,0,.46.76,7.56,7.56,0,0,0,1.81,1.19,1.64,1.64,0,0,0,1.31.16,1.13,1.13,0,0,0,.61-1C219.88,275.17,217.68,274.51,216.34,275.08Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.61,280.5a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.53,3.53,0,0,1,216.61,280.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,281.47a4.68,4.68,0,0,1-3.39-5,4.45,4.45,0,0,0-.23,3.06,4.54,4.54,0,0,0,8.75,0,3,3,0,0,0,.12-.58C221,280.5,219.07,282.33,216,281.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.33,278.76a3.61,3.61,0,0,1,1.7,2.79,1.16,1.16,0,0,1-.44,1.07l-25.7,15.71-2.4-3.95,25.7-15.72A1.16,1.16,0,0,1,213.33,278.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,296.47a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,185,296.47Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,292.05a1,1,0,0,0-.66.74,1.07,1.07,0,0,0,.46.77,7.23,7.23,0,0,0,1.81,1.18,1.69,1.69,0,0,0,1.31.17,1.14,1.14,0,0,0,.61-1C192.53,292.15,190.33,291.49,189,292.05Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.26,297.47a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.52,3.52,0,0,1,189.26,297.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,298.45a4.69,4.69,0,0,1-3.39-5,4.42,4.42,0,0,0-.23,3.05,4.54,4.54,0,0,0,8.75,0,2.94,2.94,0,0,0,.12-.59C193.61,297.48,191.72,299.31,188.64,298.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.45,247.55a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,197.45,247.55Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.45,247.55a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,197.45,247.55Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42,243.13a1,1,0,0,0-.66.74,1.06,1.06,0,0,0,.45.76,7.23,7.23,0,0,0,1.82,1.19,1.64,1.64,0,0,0,1.31.16,1.12,1.12,0,0,0,.61-1C205,243.22,202.76,242.56,201.42,243.13Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.69,248.55a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.54,3.54,0,0,1,201.69,248.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.07,249.52a4.69,4.69,0,0,1-3.4-5,4.47,4.47,0,0,0-.22,3.05,4.54,4.54,0,0,0,8.75,0,5.41,5.41,0,0,0,.12-.58C206,248.55,204.15,250.38,201.07,249.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.88,247.92a3.6,3.6,0,0,1,3.25.36,1.14,1.14,0,0,1,.57,1c0,.34-3.64,34.67-3.64,34.67l-4.6-.51s3.6-34.33,3.64-34.68A1.18,1.18,0,0,1,199.88,247.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,284.33a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,193.26,284.33Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.23,279.91a1,1,0,0,0-.66.74,1.09,1.09,0,0,0,.46.77,7.23,7.23,0,0,0,1.81,1.18,1.69,1.69,0,0,0,1.31.17,1.14,1.14,0,0,0,.61-1C200.77,280,198.57,279.35,197.23,279.91Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,285.33a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.53,3.53,0,0,1,197.5,285.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.88,286.31a4.69,4.69,0,0,1-3.39-5,4.48,4.48,0,0,0-.23,3.05,4.54,4.54,0,0,0,8.75,0,3.09,3.09,0,0,0,.12-.59C201.85,285.33,200,287.17,196.88,286.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.67,292.12a4.55,4.55,0,1,1,2.23,6A4.55,4.55,0,0,1,220.67,292.12Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.67,292.12a4.55,4.55,0,1,1,2.23,6A4.55,4.55,0,0,1,220.67,292.12Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.56,291.31a1,1,0,0,0-1,.14,1.12,1.12,0,0,0-.15.88,7.58,7.58,0,0,0,.63,2.08,1.63,1.63,0,0,0,.89,1,1.1,1.1,0,0,0,1.13-.38C229.2,293.67,228,291.75,226.56,291.31Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.27,295.63a4.29,4.29,0,0,1,2.46-6.05,4.54,4.54,0,1,0,2.11,7.81A3.53,3.53,0,0,1,223.27,295.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.16,296a4.69,4.69,0,0,1,.66-6,4.53,4.53,0,0,0,.08,8.2,4.5,4.5,0,0,0,4.47-.38,4,4,0,0,0,.47-.37C226.59,298.43,224,298.61,222.16,296Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,293.49a3.6,3.6,0,0,1,1,3.12,1.14,1.14,0,0,1-.69.93l-37.13,11-1.37-4.42s36.8-10.9,37.14-11A1.15,1.15,0,0,1,222,293.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.76,
    cy: 306.21,
    r: 4.54,
    transform: "translate(-47.68 34.24) rotate(-9.43)",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,303c-.33.12-.67.35-.7.7a1.07,1.07,0,0,0,.41.79,7.4,7.4,0,0,0,1.75,1.29,1.61,1.61,0,0,0,1.29.23,1.1,1.1,0,0,0,.67-1C187.06,303.29,184.91,302.5,183.54,303Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.5,308.42a4.28,4.28,0,0,1-1.66-6.32,4.54,4.54,0,1,0,6.37,5A3.53,3.53,0,0,1,183.5,308.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.82,309.35a4.7,4.7,0,0,1-3.1-5.21,4.54,4.54,0,1,0,8.34,3.52,2.91,2.91,0,0,0,.15-.58C187.84,308.67,185.85,310.39,182.82,309.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,328.23a4.54,4.54,0,1,1,2.19-6A4.55,4.55,0,0,1,185.13,328.23Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,325a.94.94,0,0,0,.83.53,1,1,0,0,0,.68-.57,7.34,7.34,0,0,0,.87-2,1.65,1.65,0,0,0-.05-1.31,1.12,1.12,0,0,0-1.12-.44C179.62,321.54,179.33,323.81,180.12,325Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,323.88a4.28,4.28,0,0,1-5.79,3,4.54,4.54,0,1,0,3.44-7.32A3.54,3.54,0,0,1,185.42,323.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.48,324.33a4.69,4.69,0,0,1-4.4,4.18,4.54,4.54,0,1,0,1.59-8.91,4,4,0,0,0-.6,0C184.7,319.59,186.82,321.15,186.48,324.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,326.11a3.61,3.61,0,0,1,.73-3.19,1.17,1.17,0,0,1,1.07-.45l40.19,9.33L225,336.31s-39.86-9.24-40.19-9.33A1.17,1.17,0,0,1,184.07,326.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.06,
    cy: 333.95,
    r: 4.54,
    transform: "translate(-173.68 280.76) rotate(-48.32)",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.06,
    cy: 333.95,
    r: 4.54,
    transform: "translate(-173.68 280.76) rotate(-48.32)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,331.14a1,1,0,0,0-1,.2,1,1,0,0,0-.1.88,7.14,7.14,0,0,0,.74,2,1.63,1.63,0,0,0,.94.92,1.13,1.13,0,0,0,1.11-.45C230.43,333.34,229.08,331.5,227.66,331.14Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.63,335.64a4.27,4.27,0,0,1,2.11-6.18,4.54,4.54,0,1,0,2.55,7.68A3.53,3.53,0,0,1,224.63,335.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54,336a4.67,4.67,0,0,1,.31-6.05,4.48,4.48,0,0,0-2,2.3,4.55,4.55,0,0,0,7,5.25,5.82,5.82,0,0,0,.45-.4C228.1,338.25,225.49,338.58,223.54,336Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.19,315.74s-37.57,2.1-41.47,2.3a.17.17,0,0,0-.12,0c-.65,0-1.13-1-1.15-2.23s.41-2.28,1.37-2.39h.05L226,311.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.82,320.2a4.54,4.54,0,1,1,2.06-6.08A4.54,4.54,0,0,1,183.82,320.2Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.74,317.12a1,1,0,0,0,.85.51,1,1,0,0,0,.66-.59,7.3,7.3,0,0,0,.83-2,1.61,1.61,0,0,0-.09-1.31,1.1,1.1,0,0,0-1.12-.42C178.17,313.63,177.93,315.91,178.74,317.12Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,315.84a4.28,4.28,0,0,1-5.72,3.15,4.54,4.54,0,1,0,3.28-7.39A3.52,3.52,0,0,1,184,315.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.09,316.28a4.7,4.7,0,0,1-4.31,4.27,4.49,4.49,0,0,0,3-.35,4.54,4.54,0,0,0-1.65-8.6q-.3,0-.6,0C183.2,311.58,185.35,313.09,185.09,316.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,311.31a4.55,4.55,0,1,1,2.05,6.09A4.55,4.55,0,0,1,223.78,311.31Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,311.31a4.55,4.55,0,1,1,2.05,6.09A4.55,4.55,0,0,1,223.78,311.31Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.69,310.68a1,1,0,0,0-1,.11,1.11,1.11,0,0,0-.18.88,7.88,7.88,0,0,0,.56,2.09,1.64,1.64,0,0,0,.86,1,1.12,1.12,0,0,0,1.15-.34C232.26,313.12,231.07,311.16,229.69,310.68Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.27,314.89a4.28,4.28,0,0,1,2.65-6,4.54,4.54,0,1,0,1.86,7.88A3.53,3.53,0,0,1,226.27,314.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,315.2a4.71,4.71,0,0,1,.84-6,4.54,4.54,0,0,0-.16,8.21,4.53,4.53,0,0,0,4.47-.24,4.29,4.29,0,0,0,.48-.36C229.5,317.8,226.87,317.9,225.15,315.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,242.68a4.55,4.55,0,1,1,4.9-4.16A4.55,4.55,0,0,1,191.41,242.68Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,242.68a4.55,4.55,0,1,1,4.9-4.16A4.55,4.55,0,0,1,191.41,242.68Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,237.42a.93.93,0,0,0,.46.87,1,1,0,0,0,.88-.16,7.56,7.56,0,0,0,1.74-1.29,1.66,1.66,0,0,0,.6-1.17,1.1,1.1,0,0,0-.75-.93C189.94,234.14,188.57,236,188.64,237.42Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82,239a4.29,4.29,0,0,1-6.53-.24,4.54,4.54,0,1,0,6.62-4.66A3.54,3.54,0,0,1,193.82,239Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.52,240a4.69,4.69,0,0,1-5.89,1.45,4.47,4.47,0,0,0,2.78,1.27,4.55,4.55,0,0,0,3-8.23,4.33,4.33,0,0,0-.51-.31C195.32,235,196.39,237.36,194.52,240Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.25,240.57a3.64,3.64,0,0,1,2.9-1.52,1.15,1.15,0,0,1,1,.51l16.68,31.52-4.1,2.14L191.08,241.7A1.16,1.16,0,0,1,191.25,240.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,271.76a4.55,4.55,0,1,1,5.6,3.16A4.54,4.54,0,0,1,204.69,271.76Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,267.34a.94.94,0,0,0-.66.74,1.06,1.06,0,0,0,.45.76,7.82,7.82,0,0,0,1.82,1.19,1.63,1.63,0,0,0,1.3.16,1.11,1.11,0,0,0,.62-1C212.2,267.43,210,266.77,208.67,267.34Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.94,272.76a4.29,4.29,0,0,1-2-6.21,4.54,4.54,0,1,0,6.66,4.61A3.54,3.54,0,0,1,208.94,272.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.31,273.73a4.69,4.69,0,0,1-3.39-5,4.54,4.54,0,1,0,8.53,3c.05-.19.09-.39.12-.58C213.28,272.76,211.4,274.59,208.31,273.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,233.39a4.54,4.54,0,1,1,5.15,3.84A4.55,4.55,0,0,1,182.47,233.39Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,233.39a4.54,4.54,0,1,1,5.15,3.84A4.55,4.55,0,0,1,182.47,233.39Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,229.51a.93.93,0,0,0-.75.65,1.09,1.09,0,0,0,.35.82,7.61,7.61,0,0,0,1.65,1.4,1.66,1.66,0,0,0,1.27.33,1.13,1.13,0,0,0,.75-.94C190.47,230.05,188.38,229.12,187,229.51Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.55,234.92a4.29,4.29,0,0,1-1.21-6.42,4.54,4.54,0,1,0,6,5.42A3.54,3.54,0,0,1,186.55,234.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,235.81a4.69,4.69,0,0,1-2.72-5.42,4.54,4.54,0,1,0,8.07,4.09,5.27,5.27,0,0,0,.19-.56C190.86,235.47,188.76,237.05,185.81,235.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,235.26a3.55,3.55,0,0,1,1.94-2.55,1.13,1.13,0,0,1,1.14,0c.27.2,28.49,23.33,28.49,23.33l-2.76,3.6-28.49-23.33A1.14,1.14,0,0,1,187.56,235.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.26,259.32a4.54,4.54,0,1,1,5.14,3.85A4.54,4.54,0,0,1,214.26,259.32Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,255.45c-.33.09-.69.3-.74.64a1.06,1.06,0,0,0,.35.82,7.43,7.43,0,0,0,1.65,1.41,1.66,1.66,0,0,0,1.27.33,1.13,1.13,0,0,0,.75-.94C222.26,256,220.16,255.05,218.76,255.45Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,260.86a4.28,4.28,0,0,1-1.21-6.42,4.54,4.54,0,1,0,6,5.42A3.56,3.56,0,0,1,218.34,260.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.6,261.74a4.7,4.7,0,0,1-2.73-5.42,4.54,4.54,0,1,0,8.08,4.1,5.27,5.27,0,0,0,.19-.56C222.65,261.41,220.55,263,217.6,261.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.37,181.94A4.54,4.54,0,1,1,218,185.1,4.54,4.54,0,0,1,212.37,181.94Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.34,177.52a1,1,0,0,0-.66.74,1.09,1.09,0,0,0,.46.77,7.23,7.23,0,0,0,1.81,1.18,1.69,1.69,0,0,0,1.31.17,1.14,1.14,0,0,0,.61-1C219.88,177.62,217.68,177,216.34,177.52Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.61,182.94a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.53,3.53,0,0,1,216.61,182.94Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,183.92a4.68,4.68,0,0,1-3.39-5,4.42,4.42,0,0,0-.23,3.05,4.54,4.54,0,0,0,8.75,0,2.94,2.94,0,0,0,.12-.59C221,182.94,219.07,184.78,216,183.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.33,181.2A3.61,3.61,0,0,1,215,184a1.15,1.15,0,0,1-.44,1.06l-25.7,15.71-2.4-4s25.39-15.54,25.7-15.71A1.16,1.16,0,0,1,213.33,181.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,198.92a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,185,198.92Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,198.92a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,185,198.92Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,194.5a1,1,0,0,0-.66.74,1.09,1.09,0,0,0,.46.77,7.23,7.23,0,0,0,1.81,1.18,1.64,1.64,0,0,0,1.31.16,1.11,1.11,0,0,0,.61-1C192.53,194.59,190.33,193.93,189,194.5Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.26,199.92a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.53,3.53,0,0,1,189.26,199.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,200.9a4.69,4.69,0,0,1-3.39-5,4.42,4.42,0,0,0-.23,3,4.54,4.54,0,0,0,8.75,0,2.85,2.85,0,0,0,.12-.58C193.61,199.92,191.72,201.76,188.64,200.9Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.45,150a4.54,4.54,0,1,1,5.59,3.16A4.55,4.55,0,0,1,197.45,150Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42,145.58a1,1,0,0,0-.66.73,1.06,1.06,0,0,0,.45.77,7.82,7.82,0,0,0,1.82,1.19,1.64,1.64,0,0,0,1.31.16,1.13,1.13,0,0,0,.61-1C205,145.67,202.76,145,201.42,145.58Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.69,151a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.6A3.54,3.54,0,0,1,201.69,151Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.07,152a4.7,4.7,0,0,1-3.4-5,4.54,4.54,0,1,0,8.53,3,5.6,5.6,0,0,0,.12-.59C206,151,204.15,152.83,201.07,152Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.88,150.37a3.63,3.63,0,0,1,3.25.35,1.16,1.16,0,0,1,.57,1c0,.34-3.64,34.67-3.64,34.67l-4.6-.52s3.6-34.32,3.64-34.67A1.16,1.16,0,0,1,199.88,150.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,186.78a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,193.26,186.78Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,186.78a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,193.26,186.78Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.23,182.36a1,1,0,0,0-.66.74,1.07,1.07,0,0,0,.46.76,7,7,0,0,0,1.81,1.19,1.64,1.64,0,0,0,1.31.16,1.12,1.12,0,0,0,.61-1C200.77,182.45,198.57,181.79,197.23,182.36Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,187.78a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.53,3.53,0,0,1,197.5,187.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.88,188.76a4.7,4.7,0,0,1-3.39-5,4.47,4.47,0,0,0-.23,3.05,4.54,4.54,0,0,0,8.75,0,2.85,2.85,0,0,0,.12-.58C201.85,187.78,200,189.61,196.88,188.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.67,194.57a4.54,4.54,0,1,1,2.23,6A4.55,4.55,0,0,1,220.67,194.57Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.56,193.76a1,1,0,0,0-1,.14,1.1,1.1,0,0,0-.15.88,7.51,7.51,0,0,0,.63,2.07,1.65,1.65,0,0,0,.89,1,1.12,1.12,0,0,0,1.13-.38C229.2,196.11,228,194.19,226.56,193.76Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.27,198.07a4.29,4.29,0,0,1,2.46-6,4.54,4.54,0,1,0,2.11,7.82A3.53,3.53,0,0,1,223.27,198.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.16,198.41a4.69,4.69,0,0,1,.66-6,4.54,4.54,0,1,0,4.55,7.83,5.45,5.45,0,0,0,.47-.37C226.59,200.88,224,201.06,222.16,198.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,195.94a3.59,3.59,0,0,1,1,3.12,1.16,1.16,0,0,1-.69.93l-37.13,11-1.37-4.42,37.14-11A1.16,1.16,0,0,1,222,195.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.76,
    cy: 208.66,
    r: 4.54,
    transform: "translate(-31.7 32.92) rotate(-9.43)",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.76,
    cy: 208.66,
    r: 4.54,
    transform: "translate(-31.7 32.92) rotate(-9.43)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,205.44c-.33.11-.67.35-.7.7a1.07,1.07,0,0,0,.41.79,7.69,7.69,0,0,0,1.75,1.29,1.65,1.65,0,0,0,1.29.23,1.1,1.1,0,0,0,.67-1C187.06,205.73,184.91,205,183.54,205.44Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.5,210.86a4.27,4.27,0,0,1-1.66-6.31,4.54,4.54,0,1,0,6.37,5A3.53,3.53,0,0,1,183.5,210.86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.82,211.8a4.7,4.7,0,0,1-3.1-5.21,4.54,4.54,0,1,0,8.34,3.52,2.91,2.91,0,0,0,.15-.58C187.84,211.11,185.85,212.84,182.82,211.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,230.68a4.54,4.54,0,1,1,2.19-6A4.55,4.55,0,0,1,185.13,230.68Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,230.68a4.54,4.54,0,1,1,2.19-6A4.55,4.55,0,0,1,185.13,230.68Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,227.49a1,1,0,0,0,.83.53,1.05,1.05,0,0,0,.68-.58,7.21,7.21,0,0,0,.87-2,1.65,1.65,0,0,0-.05-1.31,1.13,1.13,0,0,0-1.12-.44C179.62,224,179.33,226.26,180.12,227.49Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,226.32a4.28,4.28,0,0,1-5.79,3,4.54,4.54,0,1,0,3.44-7.33A3.55,3.55,0,0,1,185.42,226.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.48,226.78a4.7,4.7,0,0,1-4.4,4.18,4.54,4.54,0,1,0,1.59-8.92c-.2,0-.4,0-.6,0C184.7,222,186.82,223.6,186.48,226.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,228.56a3.6,3.6,0,0,1,.73-3.19,1.17,1.17,0,0,1,1.07-.45l40.19,9.33-1.05,4.5s-39.86-9.24-40.19-9.33A1.13,1.13,0,0,1,184.07,228.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.06,
    cy: 236.39,
    r: 4.54,
    transform: "translate(-100.82 248.07) rotate(-48.32)",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,233.59a.94.94,0,0,0-1,.19,1.06,1.06,0,0,0-.1.89,7.14,7.14,0,0,0,.74,2,1.62,1.62,0,0,0,.94.91,1.11,1.11,0,0,0,1.11-.45C230.43,235.79,229.08,233.94,227.66,233.59Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.63,238.09a4.28,4.28,0,0,1,2.11-6.19,4.54,4.54,0,1,0,2.55,7.69A3.54,3.54,0,0,1,224.63,238.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54,238.49a4.69,4.69,0,0,1,.31-6.06,4.54,4.54,0,1,0,5,7.55,4.19,4.19,0,0,0,.45-.39C228.1,240.7,225.49,241,223.54,238.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.19,218.19l-41.47,2.3a.17.17,0,0,0-.12,0c-.65,0-1.13-1.05-1.15-2.23s.41-2.28,1.37-2.4h.05L226,213.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.82,222.65a4.54,4.54,0,1,1,2.06-6.08A4.54,4.54,0,0,1,183.82,222.65Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.82,222.65a4.54,4.54,0,1,1,2.06-6.08A4.54,4.54,0,0,1,183.82,222.65Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.74,219.57a1,1,0,0,0,.85.51,1,1,0,0,0,.66-.59,7.23,7.23,0,0,0,.83-2,1.61,1.61,0,0,0-.09-1.31,1.1,1.1,0,0,0-1.12-.41C178.17,216.08,177.93,218.36,178.74,219.57Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,218.29a4.28,4.28,0,0,1-5.72,3.15,4.54,4.54,0,1,0,3.28-7.4A3.54,3.54,0,0,1,184,218.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.09,218.72a4.7,4.7,0,0,1-4.31,4.28,4.54,4.54,0,1,0,1.39-8.95,4,4,0,0,0-.6,0C183.2,214,185.35,215.53,185.09,218.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,213.76a4.54,4.54,0,1,1,2.05,6.09A4.55,4.55,0,0,1,223.78,213.76Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.69,213.13a1,1,0,0,0-1,.11,1.09,1.09,0,0,0-.18.87,8.05,8.05,0,0,0,.56,2.1,1.67,1.67,0,0,0,.86,1,1.11,1.11,0,0,0,1.15-.35C232.26,215.56,231.07,213.61,229.69,213.13Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.27,217.34a4.28,4.28,0,0,1,2.65-6,4.54,4.54,0,1,0,1.86,7.88A3.54,3.54,0,0,1,226.27,217.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,217.65a4.7,4.7,0,0,1,.84-6,4.54,4.54,0,1,0,4.31,8,4.21,4.21,0,0,0,.48-.35C229.5,220.25,226.87,220.35,225.15,217.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,145.12a4.54,4.54,0,1,1,4.9-4.16A4.54,4.54,0,0,1,191.41,145.12Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,139.87a.93.93,0,0,0,.46.87,1,1,0,0,0,.88-.16,7.32,7.32,0,0,0,1.74-1.3,1.64,1.64,0,0,0,.6-1.16,1.11,1.11,0,0,0-.75-.94C189.94,136.58,188.57,138.42,188.64,139.87Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82,141.48a4.28,4.28,0,0,1-6.53-.24,4.54,4.54,0,1,0,6.62-4.66A3.54,3.54,0,0,1,193.82,141.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.52,142.41a4.7,4.7,0,0,1-5.89,1.45,4.54,4.54,0,1,0,5.79-7,4.39,4.39,0,0,0-.51-.32C195.32,137.4,196.39,139.81,194.52,142.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.25,143a3.64,3.64,0,0,1,2.9-1.52,1.18,1.18,0,0,1,1,.52l16.68,31.52-4.1,2.14-16.69-31.52A1.18,1.18,0,0,1,191.25,143Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,174.2a4.55,4.55,0,1,1,5.6,3.16A4.55,4.55,0,0,1,204.69,174.2Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,174.2a4.55,4.55,0,1,1,5.6,3.16A4.55,4.55,0,0,1,204.69,174.2Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,169.78c-.32.14-.65.39-.66.74a1.06,1.06,0,0,0,.45.77,7.48,7.48,0,0,0,1.82,1.18,1.67,1.67,0,0,0,1.3.17,1.13,1.13,0,0,0,.62-1C212.2,169.88,210,169.22,208.67,169.78Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.94,175.2a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.66,4.61A3.54,3.54,0,0,1,208.94,175.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.31,176.18a4.69,4.69,0,0,1-3.39-5,4.54,4.54,0,1,0,8.53,3,5.6,5.6,0,0,0,.12-.59C213.28,175.21,211.4,177,208.31,176.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,135.42a4.54,4.54,0,1,1,5.15,3.84A4.55,4.55,0,0,1,182.47,135.42Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,131.54a.93.93,0,0,0-.75.65,1.09,1.09,0,0,0,.35.82,7.61,7.61,0,0,0,1.65,1.4,1.66,1.66,0,0,0,1.27.33,1.13,1.13,0,0,0,.75-.94C190.47,132.08,188.38,131.15,187,131.54Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.55,137a4.29,4.29,0,0,1-1.21-6.42,4.54,4.54,0,1,0,6,5.42A3.54,3.54,0,0,1,186.55,137Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,137.84a4.68,4.68,0,0,1-2.72-5.42,4.54,4.54,0,1,0,8.07,4.1c.07-.19.14-.38.19-.57C190.86,137.51,188.76,139.08,185.81,137.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,137.29a3.55,3.55,0,0,1,1.94-2.55,1.13,1.13,0,0,1,1.14,0c.27.2,28.49,23.33,28.49,23.33l-2.76,3.6-28.49-23.33A1.14,1.14,0,0,1,187.56,137.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.26,161.35a4.54,4.54,0,1,1,5.14,3.85A4.54,4.54,0,0,1,214.26,161.35Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.26,161.35a4.54,4.54,0,1,1,5.14,3.85A4.54,4.54,0,0,1,214.26,161.35Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,157.48c-.33.09-.69.3-.74.64a1.06,1.06,0,0,0,.35.82,7.43,7.43,0,0,0,1.65,1.41,1.66,1.66,0,0,0,1.27.33,1.13,1.13,0,0,0,.75-.94C222.26,158,220.16,157.08,218.76,157.48Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,162.89a4.28,4.28,0,0,1-1.21-6.42,4.54,4.54,0,1,0,6,5.42A3.56,3.56,0,0,1,218.34,162.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.6,163.77a4.7,4.7,0,0,1-2.73-5.42,4.54,4.54,0,1,0,8.08,4.1,5.27,5.27,0,0,0,.19-.56C222.65,163.44,220.55,165,217.6,163.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.37,84A4.54,4.54,0,1,1,218,87.13,4.54,4.54,0,0,1,212.37,84Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.37,84A4.54,4.54,0,1,1,218,87.13,4.54,4.54,0,0,1,212.37,84Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.34,79.55a1,1,0,0,0-.66.74,1.07,1.07,0,0,0,.46.77A7.23,7.23,0,0,0,218,82.24a1.69,1.69,0,0,0,1.31.17,1.14,1.14,0,0,0,.61-1C219.88,79.65,217.68,79,216.34,79.55Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.61,85a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.53,3.53,0,0,1,216.61,85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,86a4.68,4.68,0,0,1-3.39-5,4.42,4.42,0,0,0-.23,3,4.54,4.54,0,0,0,8.75,0,2.94,2.94,0,0,0,.12-.59C221,85,219.07,86.81,216,86Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.33,83.24A3.58,3.58,0,0,1,215,86a1.15,1.15,0,0,1-.44,1.06l-25.7,15.71-2.4-4s25.39-15.54,25.7-15.71A1.14,1.14,0,0,1,213.33,83.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,101a4.54,4.54,0,1,1,5.59,3.16A4.54,4.54,0,0,1,185,101Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,96.53a1,1,0,0,0-.66.74,1.09,1.09,0,0,0,.46.77,7.23,7.23,0,0,0,1.81,1.18,1.64,1.64,0,0,0,1.31.16,1.11,1.11,0,0,0,.61-1C192.53,96.63,190.33,96,189,96.53Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.26,102a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.53,3.53,0,0,1,189.26,102Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,102.93a4.69,4.69,0,0,1-3.39-5,4.42,4.42,0,0,0-.23,3,4.54,4.54,0,0,0,8.75,0,2.85,2.85,0,0,0,.12-.58C193.61,102,191.72,103.79,188.64,102.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.45,52A4.54,4.54,0,1,1,203,55.19,4.55,4.55,0,0,1,197.45,52Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.45,52A4.54,4.54,0,1,1,203,55.19,4.55,4.55,0,0,1,197.45,52Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42,47.61a1,1,0,0,0-.66.73,1.06,1.06,0,0,0,.45.77A7.82,7.82,0,0,0,203,50.3a1.64,1.64,0,0,0,1.31.16,1.13,1.13,0,0,0,.61-1C205,47.7,202.76,47,201.42,47.61Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.69,53a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.54,3.54,0,0,1,201.69,53Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.07,54a4.7,4.7,0,0,1-3.4-5,4.54,4.54,0,1,0,8.53,3c.05-.19.09-.39.12-.58C206,53,204.15,54.86,201.07,54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.88,52.4a3.63,3.63,0,0,1,3.25.35,1.16,1.16,0,0,1,.57,1c0,.34-3.64,34.67-3.64,34.67l-4.6-.52s3.6-34.32,3.64-34.67A1.16,1.16,0,0,1,199.88,52.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.26,88.81A4.54,4.54,0,1,1,198.85,92,4.54,4.54,0,0,1,193.26,88.81Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.23,84.39a1,1,0,0,0-.66.74,1.09,1.09,0,0,0,.46.77,7.23,7.23,0,0,0,1.81,1.18,1.64,1.64,0,0,0,1.31.16,1.11,1.11,0,0,0,.61-1C200.77,84.48,198.57,83.82,197.23,84.39Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5,89.81a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.65,4.61A3.53,3.53,0,0,1,197.5,89.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.88,90.79a4.69,4.69,0,0,1-3.39-5,4.47,4.47,0,0,0-.23,3,4.54,4.54,0,0,0,8.75,0,2.85,2.85,0,0,0,.12-.58C201.85,89.81,200,91.64,196.88,90.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.67,96.6a4.54,4.54,0,1,1,2.23,6A4.55,4.55,0,0,1,220.67,96.6Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.67,96.6a4.54,4.54,0,1,1,2.23,6A4.55,4.55,0,0,1,220.67,96.6Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.56,95.79a1,1,0,0,0-1,.14,1.11,1.11,0,0,0-.15.88,7.68,7.68,0,0,0,.63,2.08,1.66,1.66,0,0,0,.89,1,1.12,1.12,0,0,0,1.13-.38C229.2,98.14,228,96.22,226.56,95.79Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.27,100.1a4.29,4.29,0,0,1,2.46-6,4.54,4.54,0,1,0,2.11,7.82A3.53,3.53,0,0,1,223.27,100.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.16,100.44a4.69,4.69,0,0,1,.66-6,4.54,4.54,0,1,0,4.55,7.83,5.45,5.45,0,0,0,.47-.37C226.59,102.91,224,103.09,222.16,100.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,98a3.59,3.59,0,0,1,1,3.12,1.16,1.16,0,0,1-.69.93l-37.13,11-1.37-4.42,37.14-11A1.16,1.16,0,0,1,222,98Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.32,111.65a4.54,4.54,0,1,1,5.4,3.48A4.54,4.54,0,0,1,179.32,111.65Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,107.47c-.33.11-.67.35-.7.7a1.07,1.07,0,0,0,.41.79,7.69,7.69,0,0,0,1.75,1.29,1.61,1.61,0,0,0,1.29.23,1.1,1.1,0,0,0,.67-1C187.06,107.76,184.91,107,183.54,107.47Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.5,112.89a4.27,4.27,0,0,1-1.66-6.31,4.54,4.54,0,1,0,6.37,5A3.53,3.53,0,0,1,183.5,112.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.82,113.83a4.7,4.7,0,0,1-3.1-5.21,4.54,4.54,0,1,0,8.34,3.52,2.91,2.91,0,0,0,.15-.58C187.84,113.14,185.85,114.87,182.82,113.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,132.71a4.54,4.54,0,1,1,2.19-6A4.55,4.55,0,0,1,185.13,132.71Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.12,129.52a1,1,0,0,0,.83.53,1.05,1.05,0,0,0,.68-.58,7.21,7.21,0,0,0,.87-2,1.65,1.65,0,0,0-.05-1.31,1.13,1.13,0,0,0-1.12-.44C179.62,126,179.33,128.29,180.12,129.52Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,128.35a4.28,4.28,0,0,1-5.79,3,4.54,4.54,0,1,0,3.44-7.33A3.55,3.55,0,0,1,185.42,128.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.48,128.81a4.7,4.7,0,0,1-4.4,4.18,4.54,4.54,0,1,0,1.59-8.91q-.3,0-.6,0C184.7,124.07,186.82,125.63,186.48,128.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.07,130.59a3.6,3.6,0,0,1,.73-3.19,1.17,1.17,0,0,1,1.07-.45l40.19,9.33-1.05,4.5-40.19-9.32A1.17,1.17,0,0,1,184.07,130.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.06,
    cy: 138.42,
    r: 4.54,
    transform: "translate(-27.64 215.24) rotate(-48.32)",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.06,
    cy: 138.42,
    r: 4.54,
    transform: "translate(-27.64 215.24) rotate(-48.32)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,135.62a.92.92,0,0,0-1,.2,1,1,0,0,0-.1.88,7.14,7.14,0,0,0,.74,2,1.59,1.59,0,0,0,.94.91,1.11,1.11,0,0,0,1.11-.45C230.43,137.82,229.08,136,227.66,135.62Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.63,140.12a4.27,4.27,0,0,1,2.11-6.18,4.54,4.54,0,1,0,2.55,7.68A3.54,3.54,0,0,1,224.63,140.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54,140.52a4.69,4.69,0,0,1,.31-6.06,4.54,4.54,0,1,0,5,7.55,4.19,4.19,0,0,0,.45-.39C228.1,142.73,225.49,143.06,223.54,140.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.19,120.22l-41.47,2.3a.17.17,0,0,0-.12,0c-.65,0-1.13-1-1.15-2.23s.41-2.28,1.37-2.4h.05L226,115.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.82,124.68a4.54,4.54,0,1,1,2.06-6.08A4.54,4.54,0,0,1,183.82,124.68Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.74,121.6a1,1,0,0,0,.85.51,1,1,0,0,0,.66-.59,7.23,7.23,0,0,0,.83-2,1.61,1.61,0,0,0-.09-1.31,1.1,1.1,0,0,0-1.12-.41C178.17,118.11,177.93,120.39,178.74,121.6Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,120.32a4.28,4.28,0,0,1-5.72,3.15,4.54,4.54,0,1,0,3.28-7.4A3.54,3.54,0,0,1,184,120.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.09,120.75a4.7,4.7,0,0,1-4.31,4.28,4.54,4.54,0,1,0,1.39-9c-.2,0-.4,0-.6,0C183.2,116.05,185.35,117.56,185.09,120.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,115.79a4.54,4.54,0,1,1,2.05,6.09A4.55,4.55,0,0,1,223.78,115.79Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.78,115.79a4.54,4.54,0,1,1,2.05,6.09A4.55,4.55,0,0,1,223.78,115.79Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.69,115.16a1,1,0,0,0-1,.11,1.09,1.09,0,0,0-.18.87,8.05,8.05,0,0,0,.56,2.1,1.67,1.67,0,0,0,.86,1,1.11,1.11,0,0,0,1.15-.35C232.26,117.6,231.07,115.64,229.69,115.16Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.27,119.37a4.28,4.28,0,0,1,2.65-6,4.54,4.54,0,1,0,1.86,7.88A3.54,3.54,0,0,1,226.27,119.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.15,119.68a4.7,4.7,0,0,1,.84-6,4.54,4.54,0,1,0,4.31,8,3.27,3.27,0,0,0,.48-.35C229.5,122.28,226.87,122.38,225.15,119.68Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,47.15a4.54,4.54,0,1,1,4.9-4.16A4.54,4.54,0,0,1,191.41,47.15Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,47.15a4.54,4.54,0,1,1,4.9-4.16A4.54,4.54,0,0,1,191.41,47.15Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,41.9a.93.93,0,0,0,.46.87,1,1,0,0,0,.88-.16,7.32,7.32,0,0,0,1.74-1.3,1.64,1.64,0,0,0,.6-1.16,1.11,1.11,0,0,0-.75-.94C189.94,38.61,188.57,40.45,188.64,41.9Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82,43.51a4.28,4.28,0,0,1-6.53-.24,4.54,4.54,0,1,0,6.62-4.66A3.54,3.54,0,0,1,193.82,43.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.52,44.44a4.7,4.7,0,0,1-5.89,1.45,4.54,4.54,0,1,0,5.79-7,4.39,4.39,0,0,0-.51-.32C195.32,39.43,196.39,41.84,194.52,44.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.25,45a3.64,3.64,0,0,1,2.9-1.52,1.18,1.18,0,0,1,1,.52l16.68,31.52-4.1,2.14L191.08,46.18A1.18,1.18,0,0,1,191.25,45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,76.23a4.55,4.55,0,1,1,5.6,3.16A4.55,4.55,0,0,1,204.69,76.23Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,71.81c-.32.14-.65.39-.66.74a1.06,1.06,0,0,0,.45.77,7.48,7.48,0,0,0,1.82,1.18,1.67,1.67,0,0,0,1.3.17,1.13,1.13,0,0,0,.62-1C212.2,71.91,210,71.25,208.67,71.81Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.94,77.23a4.28,4.28,0,0,1-2-6.21,4.54,4.54,0,1,0,6.66,4.61A3.54,3.54,0,0,1,208.94,77.23Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.31,78.21a4.69,4.69,0,0,1-3.39-5,4.54,4.54,0,1,0,8.53,3,5.6,5.6,0,0,0,.12-.59C213.28,77.24,211.4,79.07,208.31,78.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,36.94a4.54,4.54,0,1,1,5.14,3.84A4.54,4.54,0,0,1,179.45,36.94Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.45,36.94a4.54,4.54,0,1,1,5.14,3.84A4.54,4.54,0,0,1,179.45,36.94Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,33.06c-.33.09-.69.3-.74.65a1,1,0,0,0,.35.82,7.17,7.17,0,0,0,1.65,1.4,1.66,1.66,0,0,0,1.27.33,1.11,1.11,0,0,0,.74-.94C187.45,33.6,185.35,32.67,184,33.06Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.53,38.47a4.28,4.28,0,0,1-1.22-6.42,4.54,4.54,0,1,0,6,5.42A3.54,3.54,0,0,1,183.53,38.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.79,39.36a4.69,4.69,0,0,1-2.73-5.42,4.46,4.46,0,0,0-.61,3,4.54,4.54,0,0,0,8.68,1.1c.08-.19.14-.38.2-.57C187.84,39,185.74,40.6,182.79,39.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.53,38.81a3.58,3.58,0,0,1,1.95-2.55,1.11,1.11,0,0,1,1.13,0l31.52,23.84-2.76,3.6L184.85,39.89A1.17,1.17,0,0,1,184.53,38.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.26,63.38a4.54,4.54,0,1,1,5.14,3.85A4.54,4.54,0,0,1,214.26,63.38Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,59.51c-.33.09-.69.3-.74.64a1.06,1.06,0,0,0,.35.82A7.43,7.43,0,0,0,220,62.38a1.66,1.66,0,0,0,1.27.33,1.13,1.13,0,0,0,.75-.94C222.26,60.05,220.16,59.11,218.76,59.51Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,64.92a4.28,4.28,0,0,1-1.21-6.42,4.54,4.54,0,1,0,6,5.42A3.55,3.55,0,0,1,218.34,64.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.6,65.8a4.7,4.7,0,0,1-2.73-5.42,4.54,4.54,0,1,0,8.08,4.1,5.27,5.27,0,0,0,.19-.56C222.65,65.47,220.55,67.05,217.6,65.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,116.31c.13-.71.28-1.39.46-2.09.06-.25-1.46-.62-1.53-.36-.2.75-.38,1.45-.53,2.21A5,5,0,0,1,183.29,116.31Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9,102.76c-.67,1.18-1.28,2.35-1.88,3.56a4.64,4.64,0,0,1,1.34.65c.57-1.19,1.13-2.28,1.83-3.49C188.41,103.13,187.05,102.48,186.9,102.76Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9,90.32c-.69,1.09-2.9,4.34-3.56,5.31a5.2,5.2,0,0,1,1.22.85c.54-.8,2.79-4.08,3.58-5.33C196.36,90.85,195.08,90,194.9,90.32Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.47,76.8c-2,2.3-3.81,4.43-5.76,6.75a5.39,5.39,0,0,1,1.13.83c1.78-2.21,3.66-4.32,5.5-6.47l.09-.12C206.63,77.57,205.72,76.52,205.47,76.8Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.78,64.8c-.82.93-1.65,1.86-2.46,2.8l-2.69,3.15a5.35,5.35,0,0,1,1.17.64c.71-.84,1.42-1.64,2.12-2.49.94-1.12,1.85-2.14,2.79-3.26C217,65.36,216.06,64.5,215.78,64.8Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.29,116.31c.13-.71.28-1.39.46-2.09.06-.25-1.46-.62-1.53-.36-.2.75-.38,1.45-.53,2.21A5,5,0,0,1,183.29,116.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.9,102.76c-.67,1.18-1.28,2.35-1.88,3.56a4.64,4.64,0,0,1,1.34.65c.57-1.19,1.13-2.28,1.83-3.49C188.41,103.13,187.05,102.48,186.9,102.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.9,90.32c-.69,1.09-2.9,4.34-3.56,5.31a5.2,5.2,0,0,1,1.22.85c.54-.8,2.79-4.08,3.58-5.33C196.36,90.85,195.08,90,194.9,90.32Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.47,76.8c-2,2.3-3.81,4.43-5.76,6.75a5.39,5.39,0,0,1,1.13.83c1.78-2.21,3.66-4.32,5.5-6.47l.09-.12C206.63,77.57,205.72,76.52,205.47,76.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.78,64.8c-.82.93-1.65,1.86-2.46,2.8l-2.69,3.15a5.35,5.35,0,0,1,1.17.64c.71-.84,1.42-1.64,2.12-2.49.94-1.12,1.85-2.14,2.79-3.26C217,65.36,216.06,64.5,215.78,64.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,214.28c.13-.71.28-1.39.46-2.09.06-.25-1.46-.62-1.53-.36-.2.75-.38,1.45-.53,2.2A5.05,5.05,0,0,1,183.29,214.28Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9,200.73c-.67,1.18-1.28,2.35-1.88,3.56a4.64,4.64,0,0,1,1.34.65c.57-1.19,1.13-2.29,1.83-3.49C188.41,201.1,187.05,200.45,186.9,200.73Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9,188.29c-.69,1.09-2.9,4.34-3.56,5.31a5.2,5.2,0,0,1,1.22.85c.54-.8,2.79-4.08,3.58-5.33C196.36,188.82,195.08,188,194.9,188.29Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.47,174.77c-2,2.3-3.81,4.43-5.76,6.75a5.39,5.39,0,0,1,1.13.83c1.78-2.21,3.66-4.32,5.5-6.47l.09-.12C206.63,175.54,205.72,174.49,205.47,174.77Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.78,162.77c-.82.93-1.65,1.86-2.46,2.8l-2.69,3.15a5.35,5.35,0,0,1,1.17.64c.71-.85,1.42-1.64,2.12-2.49.94-1.12,1.85-2.14,2.79-3.26C217,163.33,216.06,162.47,215.78,162.77Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.29,214.28c.13-.71.28-1.39.46-2.09.06-.25-1.46-.62-1.53-.36-.2.75-.38,1.45-.53,2.2A5.05,5.05,0,0,1,183.29,214.28Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186.9,200.73c-.67,1.18-1.28,2.35-1.88,3.56a4.64,4.64,0,0,1,1.34.65c.57-1.19,1.13-2.29,1.83-3.49C188.41,201.1,187.05,200.45,186.9,200.73Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.9,188.29c-.69,1.09-2.9,4.34-3.56,5.31a5.2,5.2,0,0,1,1.22.85c.54-.8,2.79-4.08,3.58-5.33C196.36,188.82,195.08,188,194.9,188.29Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.47,174.77c-2,2.3-3.81,4.43-5.76,6.75a5.39,5.39,0,0,1,1.13.83c1.78-2.21,3.66-4.32,5.5-6.47l.09-.12C206.63,175.54,205.72,174.49,205.47,174.77Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.78,162.77c-.82.93-1.65,1.86-2.46,2.8l-2.69,3.15a5.35,5.35,0,0,1,1.17.64c.71-.85,1.42-1.64,2.12-2.49.94-1.12,1.85-2.14,2.79-3.26C217,163.33,216.06,162.47,215.78,162.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,95c.12.3,1.26.06,1.14-.31A60.59,60.59,0,0,0,220.86,87c-.23-.38-.48-.85-.71-1.22a7.24,7.24,0,0,1-.87.76,61.45,61.45,0,0,1,4.06,7.86C223.43,94.57,223.5,94.78,223.58,95Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.34,113.76a64,64,0,0,0-2-11.49,3.29,3.29,0,0,1-.48.27,5.44,5.44,0,0,1-.66.28,62.67,62.67,0,0,1,1.75,9.59q.09.86.15,1.71h0a.41.41,0,0,0,.11.07h0l.11,0h.25l.25,0,.06,0,.11,0a.41.41,0,0,0,.11-.07.09.09,0,0,1,.05,0c-.08,0,0,0,0,0l.09-.09,0,0,0,0s0,0,0,0l0,0A.19.19,0,0,0,229.34,113.76Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9,135.23a.76.76,0,0,0,.22.11,1.39,1.39,0,0,0,.45.09,1,1,0,0,0,.3,0c.1,0,.16-.06.18-.17.15-.88.3-1.76.44-2.65s.26-1.75.37-2.64c.34-2.64.56-5.24.65-7.89-.09,0-.21.08-.39.13a5.26,5.26,0,0,1-.88.17c0,.84-.08,1.67-.14,2.51s-.14,1.76-.23,2.64-.19,1.75-.3,2.62-.25,1.75-.39,2.62L227,134l-.12.65C226.82,134.87,226.74,135.08,226.9,135.23Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,142.94a2.75,2.75,0,0,1-.56-.1c-.15.59-.23,1-.39,1.63a62.94,62.94,0,0,1-5,13.7c-.36.68.93,1,1.27.37a56.4,56.4,0,0,0,4.77-12.64c.27-1,.5-2,.74-3A5.14,5.14,0,0,1,225.62,142.94Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M223.58,95c.12.3,1.26.06,1.14-.31A60.59,60.59,0,0,0,220.86,87c-.23-.38-.48-.85-.71-1.22a7.24,7.24,0,0,1-.87.76,61.45,61.45,0,0,1,4.06,7.86C223.43,94.57,223.5,94.78,223.58,95Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229.34,113.76a64,64,0,0,0-2-11.49,3.29,3.29,0,0,1-.48.27,5.44,5.44,0,0,1-.66.28,62.67,62.67,0,0,1,1.75,9.59q.09.86.15,1.71h0a.41.41,0,0,0,.11.07h0l.11,0h.25l.25,0,.06,0,.11,0a.41.41,0,0,0,.11-.07.09.09,0,0,1,.05,0c-.08,0,0,0,0,0l.09-.09,0,0,0,0s0,0,0,0l0,0A.19.19,0,0,0,229.34,113.76Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M226.9,135.23a.76.76,0,0,0,.22.11,1.39,1.39,0,0,0,.45.09,1,1,0,0,0,.3,0c.1,0,.16-.06.18-.17.15-.88.3-1.76.44-2.65s.26-1.75.37-2.64c.34-2.64.56-5.24.65-7.89-.09,0-.21.08-.39.13a5.26,5.26,0,0,1-.88.17c0,.84-.08,1.67-.14,2.51s-.14,1.76-.23,2.64-.19,1.75-.3,2.62-.25,1.75-.39,2.62L227,134l-.12.65C226.82,134.87,226.74,135.08,226.9,135.23Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.62,142.94a2.75,2.75,0,0,1-.56-.1c-.15.59-.23,1-.39,1.63a62.94,62.94,0,0,1-5,13.7c-.36.68.93,1,1.27.37a56.4,56.4,0,0,0,4.77-12.64c.27-1,.5-2,.74-3A5.14,5.14,0,0,1,225.62,142.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,311.83c.13-.71.28-1.39.46-2.09.06-.25-1.46-.62-1.53-.36-.2.75-.38,1.45-.53,2.2A5.05,5.05,0,0,1,183.29,311.83Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9,298.28c-.67,1.18-1.28,2.35-1.88,3.56a4.64,4.64,0,0,1,1.34.65c.57-1.19,1.13-2.29,1.83-3.49C188.41,298.65,187.05,298,186.9,298.28Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9,285.84c-.69,1.09-2.9,4.34-3.56,5.31a5.2,5.2,0,0,1,1.22.85c.54-.8,2.79-4.08,3.58-5.33C196.36,286.37,195.08,285.53,194.9,285.84Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.47,272.32c-2,2.3-3.81,4.43-5.76,6.75a5.39,5.39,0,0,1,1.13.83c1.78-2.21,3.66-4.32,5.5-6.47l.09-.12C206.63,273.09,205.72,272,205.47,272.32Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.78,260.32c-.82.93-1.65,1.86-2.46,2.8l-2.69,3.15a5.35,5.35,0,0,1,1.17.64c.71-.85,1.42-1.64,2.12-2.49.94-1.12,1.85-2.14,2.79-3.26C217,260.88,216.06,260,215.78,260.32Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.29,311.83c.13-.71.28-1.39.46-2.09.06-.25-1.46-.62-1.53-.36-.2.75-.38,1.45-.53,2.2A5.05,5.05,0,0,1,183.29,311.83Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M186.9,298.28c-.67,1.18-1.28,2.35-1.88,3.56a4.64,4.64,0,0,1,1.34.65c.57-1.19,1.13-2.29,1.83-3.49C188.41,298.65,187.05,298,186.9,298.28Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M194.9,285.84c-.69,1.09-2.9,4.34-3.56,5.31a5.2,5.2,0,0,1,1.22.85c.54-.8,2.79-4.08,3.58-5.33C196.36,286.37,195.08,285.53,194.9,285.84Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M205.47,272.32c-2,2.3-3.81,4.43-5.76,6.75a5.39,5.39,0,0,1,1.13.83c1.78-2.21,3.66-4.32,5.5-6.47l.09-.12C206.63,273.09,205.72,272,205.47,272.32Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.78,260.32c-.82.93-1.65,1.86-2.46,2.8l-2.69,3.15a5.35,5.35,0,0,1,1.17.64c.71-.85,1.42-1.64,2.12-2.49.94-1.12,1.85-2.14,2.79-3.26C217,260.88,216.06,260,215.78,260.32Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,290.49c.12.3,1.26.06,1.14-.31a60.59,60.59,0,0,0-3.86-7.68c-.23-.38-.48-.85-.71-1.22a8.24,8.24,0,0,1-.87.76,61.45,61.45,0,0,1,4.06,7.86C223.43,290.09,223.5,290.3,223.58,290.49Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.34,309.28a64,64,0,0,0-2-11.49,3.29,3.29,0,0,1-.48.27,5.44,5.44,0,0,1-.66.28,62.67,62.67,0,0,1,1.75,9.59q.09.85.15,1.71h0a.41.41,0,0,0,.11.07h0l.11,0,.06,0h.19l.25,0,.06,0,.11-.05a.41.41,0,0,0,.11-.07.09.09,0,0,1,.05,0c-.08,0,0,0,0,0l.09-.09,0-.05,0,0s0,0,0,0l0,0A.19.19,0,0,0,229.34,309.28Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9,330.75a.76.76,0,0,0,.22.11,1.39,1.39,0,0,0,.45.09,1,1,0,0,0,.3,0c.1,0,.16-.06.18-.17.15-.88.3-1.76.44-2.65s.26-1.75.37-2.64c.34-2.64.56-5.24.65-7.89l-.39.13a5.26,5.26,0,0,1-.88.17c0,.83-.08,1.67-.14,2.51s-.14,1.76-.23,2.64-.19,1.75-.3,2.62-.25,1.74-.39,2.62l-.21,1.31-.12.65C226.82,330.39,226.74,330.6,226.9,330.75Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,338.46a2.75,2.75,0,0,1-.56-.1c-.15.59-.23,1-.39,1.63a62.94,62.94,0,0,1-5,13.7c-.36.68.93,1,1.27.37a56.4,56.4,0,0,0,4.77-12.64c.27-1,.5-2,.74-2.95A6.87,6.87,0,0,1,225.62,338.46Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.4,370.7s-6.62,7.24-7,7.61.55,1.53,1.17,1.06,5.13-5.76,6.91-7.61A4.39,4.39,0,0,1,205.4,370.7Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6,359.49c-.79,1.28-4.76,5.8-4.93,6.07s.34,1.32.9,1a78.14,78.14,0,0,0,5.18-6.22A4.46,4.46,0,0,1,215.6,359.49Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M223.58,290.49c.12.3,1.26.06,1.14-.31a60.59,60.59,0,0,0-3.86-7.68c-.23-.38-.48-.85-.71-1.22a8.24,8.24,0,0,1-.87.76,61.45,61.45,0,0,1,4.06,7.86C223.43,290.09,223.5,290.3,223.58,290.49Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M229.34,309.28a64,64,0,0,0-2-11.49,3.29,3.29,0,0,1-.48.27,5.44,5.44,0,0,1-.66.28,62.67,62.67,0,0,1,1.75,9.59q.09.85.15,1.71h0a.41.41,0,0,0,.11.07h0l.11,0,.06,0h.19l.25,0,.06,0,.11-.05a.41.41,0,0,0,.11-.07.09.09,0,0,1,.05,0c-.08,0,0,0,0,0l.09-.09,0-.05,0,0s0,0,0,0l0,0A.19.19,0,0,0,229.34,309.28Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M226.9,330.75a.76.76,0,0,0,.22.11,1.39,1.39,0,0,0,.45.09,1,1,0,0,0,.3,0c.1,0,.16-.06.18-.17.15-.88.3-1.76.44-2.65s.26-1.75.37-2.64c.34-2.64.56-5.24.65-7.89l-.39.13a5.26,5.26,0,0,1-.88.17c0,.83-.08,1.67-.14,2.51s-.14,1.76-.23,2.64-.19,1.75-.3,2.62-.25,1.74-.39,2.62l-.21,1.31-.12.65C226.82,330.39,226.74,330.6,226.9,330.75Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M225.62,338.46a2.75,2.75,0,0,1-.56-.1c-.15.59-.23,1-.39,1.63a62.94,62.94,0,0,1-5,13.7c-.36.68.93,1,1.27.37a56.4,56.4,0,0,0,4.77-12.64c.27-1,.5-2,.74-2.95A6.87,6.87,0,0,1,225.62,338.46Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M215.6,359.49c-.79,1.28-4.76,5.8-4.93,6.07s.34,1.32.9,1a78.14,78.14,0,0,0,5.18-6.22A4.46,4.46,0,0,1,215.6,359.49Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M205.4,370.7s-6.62,7.24-7,7.61.55,1.53,1.17,1.06,5.13-5.76,6.91-7.61A4.39,4.39,0,0,1,205.4,370.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M223.58,192.94c.12.3,1.26.06,1.14-.31a60.59,60.59,0,0,0-3.86-7.68c-.23-.38-.48-.85-.71-1.22a8.24,8.24,0,0,1-.87.76,61.45,61.45,0,0,1,4.06,7.86C223.43,192.54,223.5,192.75,223.58,192.94Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.34,211.73a64,64,0,0,0-2-11.49,3.29,3.29,0,0,1-.48.27,5.44,5.44,0,0,1-.66.28,62.67,62.67,0,0,1,1.75,9.59q.09.85.15,1.71h0a.41.41,0,0,0,.11.07h0l.11,0,.06,0h.19l.25,0,.06,0,.11-.05a.41.41,0,0,0,.11-.07.09.09,0,0,1,.05,0c-.08,0,0,0,0,0l.09-.09,0,0,0,0s0,0,0,0l0,0A.19.19,0,0,0,229.34,211.73Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9,233.2a.76.76,0,0,0,.22.11,1.39,1.39,0,0,0,.45.09,1,1,0,0,0,.3,0c.1,0,.16-.06.18-.17.15-.88.3-1.76.44-2.65s.26-1.76.37-2.64c.34-2.64.56-5.24.65-7.89-.09,0-.21.08-.39.13a5.26,5.26,0,0,1-.88.17c0,.83-.08,1.67-.14,2.51s-.14,1.76-.23,2.64-.19,1.75-.3,2.62-.25,1.74-.39,2.62L227,232l-.12.65C226.82,232.84,226.74,233.05,226.9,233.2Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,240.91a2.75,2.75,0,0,1-.56-.1c-.15.59-.23,1-.39,1.63a62.94,62.94,0,0,1-5,13.7c-.36.68.93,1,1.27.37a56.4,56.4,0,0,0,4.77-12.64c.27-1,.5-2,.74-3A6.87,6.87,0,0,1,225.62,240.91Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M223.58,192.94c.12.3,1.26.06,1.14-.31a60.59,60.59,0,0,0-3.86-7.68c-.23-.38-.48-.85-.71-1.22a8.24,8.24,0,0,1-.87.76,61.45,61.45,0,0,1,4.06,7.86C223.43,192.54,223.5,192.75,223.58,192.94Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M229.34,211.73a64,64,0,0,0-2-11.49,3.29,3.29,0,0,1-.48.27,5.44,5.44,0,0,1-.66.28,62.67,62.67,0,0,1,1.75,9.59q.09.85.15,1.71h0a.41.41,0,0,0,.11.07h0l.11,0,.06,0h.19l.25,0,.06,0,.11-.05a.41.41,0,0,0,.11-.07.09.09,0,0,1,.05,0c-.08,0,0,0,0,0l.09-.09,0,0,0,0s0,0,0,0l0,0A.19.19,0,0,0,229.34,211.73Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M226.9,233.2a.76.76,0,0,0,.22.11,1.39,1.39,0,0,0,.45.09,1,1,0,0,0,.3,0c.1,0,.16-.06.18-.17.15-.88.3-1.76.44-2.65s.26-1.76.37-2.64c.34-2.64.56-5.24.65-7.89-.09,0-.21.08-.39.13a5.26,5.26,0,0,1-.88.17c0,.83-.08,1.67-.14,2.51s-.14,1.76-.23,2.64-.19,1.75-.3,2.62-.25,1.74-.39,2.62L227,232l-.12.65C226.82,232.84,226.74,233.05,226.9,233.2Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M225.62,240.91a2.75,2.75,0,0,1-.56-.1c-.15.59-.23,1-.39,1.63a62.94,62.94,0,0,1-5,13.7c-.36.68.93,1,1.27.37a56.4,56.4,0,0,0,4.77-12.64c.27-1,.5-2,.74-3A6.87,6.87,0,0,1,225.62,240.91Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.1,130.57c7.73-.16,9.28,1.52,14.59,12.17,4.28,8.58,9.45,18.71,12.76,22.53,7.28,1,22.22,2.15,27.93,1.25A4.4,4.4,0,0,0,157,165c1.8-2.12,3.45-2.86,5.56-4.37,1.65-1.18,2.17-2.28,2.62-2a2.18,2.18,0,0,1,.66,3,15.39,15.39,0,0,1-2.27,3,40.49,40.49,0,0,0,7.71-2.13c4.88-2,7.52-.72,6,5.64-.89,3.62-4,6.33-13.73,8.24a60.37,60.37,0,0,1-9,1.18s-24.37,0-31.86,0h-.56l0,0a10.13,10.13,0,0,1-5.89-3.31c-10.78-12.52-16-23.57-20.73-31.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1,130.57c6-.38,9,.17,10.88,3.43,4.51,7.66,14.37,29.34,16.74,30.61,1.86,1,26.62,2.08,26.62,2.08-1.22,1.29-1.75,8.55.56,10.87,0,0-26.37,1.26-31.4,1.06-2.69-.11-4.9-1.84-7.24-4.6s-15.43-18.56-15.43-18.56Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1,130.57c6-.38,9,.17,10.88,3.43,4.51,7.66,14.37,29.34,16.74,30.61,1.86,1,26.62,2.08,26.62,2.08-1.22,1.29-1.75,8.55.56,10.87,0,0-26.37,1.26-31.4,1.06-2.69-.11-4.9-1.84-7.24-4.6s-15.43-18.56-15.43-18.56Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.26,156.21s12.38,94,10.07,93.06a75.76,75.76,0,0,0-34.94-4.91,92.31,92.31,0,0,0-27.13,6.19s10.08-76.66,10.25-95.29Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.26,156.21s12.38,94,10.07,93.06a75.76,75.76,0,0,0-34.94-4.91,92.31,92.31,0,0,0-27.13,6.19s10.08-76.66,10.25-95.29Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.26,156.21s12.38,94,10.07,93.06a75.76,75.76,0,0,0-34.94-4.91,92.31,92.31,0,0,0-27.13,6.19s10.08-76.66,10.25-95.29Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-196"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.34,175.93a62.11,62.11,0,0,0-10.93,22c-5,19.51,1.83,63.16,1.83,63.16-.27,2.84-.59,7.21-1.92,19.68-1.56,14.74,3.43,53.71,3.43,53.71a10.59,10.59,0,0,0,10.22.57s7.2-56.43,9.18-71.07c1.73-12.78,4.36-41.14,4.36-41.14l7,39.38s-1.1,7.16-1.68,12.62c-.92,8.62,7.08,52,7.08,52s3.91,2.11,9.52-.1c0,0,2.85-55.19,3.72-65.57.9-10.69-.25-36.34-2.12-56.19-.56-6-2.42-21.83-3.43-27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.78,330.94c.34,2.19,2.4,6.55,9.62,11.86,1.33,1,3.62,2.71,4.69,3.42,4.71,3.11,6.92,4.19,5.48,6.49s-4.67,3-8.81,3a19,19,0,0,1-11-4.44,22,22,0,0,0-7.89-4.77c-3-.77-6.42-2.58-6.7-4.17a17.08,17.08,0,0,1,.29-6.14,22.27,22.27,0,0,0,.7-4.54c0-1.81-.25-5.81-.67-9.64s-1.45-8.2.08-8.55l.27,1.68s1.27,1.42,5.77,1.21,6.45-1.4,6.45-1.4l.07-1.37s1.24-.26,1.17,1.14S112.43,328.74,112.78,330.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.88,338.66c-.1,2.19,0,3.3-.07,6.71a77.71,77.71,0,0,0,1,12.43c.7,5.08,1,7.74-1.44,12.68s-8.35,1.91-10.42-1-3-4.86-2.75-10c.18-4.52,1.21-6.46,1.37-12,.14-5.14.53-7.24.48-9.07,0-1.64-.74-8.59-.91-10.11s.6-1.94.6-1.94l.18,1.58s1,1.75,5.65,1.73,6.22-1.47,6.22-1.47l.2-1.54s.83.39.63,1.79S76,336.47,75.88,338.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.51,222.84l1.87-12.09a30.16,30.16,0,0,0,14.3-4.48,18.19,18.19,0,0,1-12,6.56l-1.21,10.83,3.22,33.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.08,163.12c-.22,3.56.55,14.87.55,14.87-14.61,9.7-36.29-2.06-36.29-2.06l-2.83-20.67s7.68-10.54.67-21.78l11.37-2.14,13.54-1,4,.22c4.41,3.3,10.62,12.2,12,15.86S114.6,155.59,108.08,163.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37,125c2.3.58,4.43,1.09,6.24,2.83,2.67,2.59,5.84,8.67,7.5,14.82,0-.11-4.93-7.68-8.87-11.16-.86-.75-4.93-.92-4.93-.92Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37,125c2.3.58,4.43,1.09,6.24,2.83,2.67,2.59,5.84,8.67,7.5,14.82,0-.11-4.93-7.68-8.87-11.16-.86-.75-4.93-.92-4.93-.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.77,131.18a116.31,116.31,0,0,1,4.78,28.93c.31,11.42-4.93,47.42-5,59.69-.14,14.8-1,41-1,41A83.56,83.56,0,0,1,67,258.29a25.07,25.07,0,0,1-10.75-6.64s.53-28.44,2.56-42.85c1.92-13.66,8.39-26.6,8.69-32.91.22-4.49-6.09-35.61-6.09-35.61s.49-6.12,6.27-7.78C73.18,130.92,81.77,131.18,81.77,131.18Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.77,131.18a116.31,116.31,0,0,1,4.78,28.93c.31,11.42-4.93,47.42-5,59.69-.14,14.8-1,41-1,41A83.56,83.56,0,0,1,67,258.29a25.07,25.07,0,0,1-10.75-6.64s.53-28.44,2.56-42.85c1.92-13.66,8.39-26.6,8.69-32.91.22-4.49-6.09-35.61-6.09-35.61s.49-6.12,6.27-7.78C73.18,130.92,81.77,131.18,81.77,131.18Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.49,175.89c.09-1.76-.83-7.62-2-14.09v-.57L73.59,138a43.94,43.94,0,0,1-2,15.61c-2,6.86-3,9.32-3,9.32l4.91,15.91s-6.83,4.57-12.71,20.66C63.4,189.49,67.26,180.73,67.49,175.89Z",
    style: {
      fill: "#2F8AE1",
      opacity: 0.05
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.08,125.59h0c-9.2-.09-25.49-9.54-25.35-24.51h0C69.84,89.16,78.06,79.73,90,79.84l2.51,0a23,23,0,0,1,13.3,4c10.81-.85,17.34,14.5,4.5,19.8C102.7,109,95.24,108.08,95.08,125.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.69,87.92a5.54,5.54,0,0,0-4.65-1,11.13,11.13,0,0,0-5.66,2.42,19.11,19.11,0,0,0-6.56,11.25c-.82,4-.8,8.16-1.17,12.25s-1.15,8.27-3.38,11.72c-.62,1-1.37,2.15-.81,3.14a2.54,2.54,0,0,0,1.43,1,10.68,10.68,0,0,0,9.47-1.21,11,11,0,0,0,5.08-8.65,26.3,26.3,0,0,0-.25-6.23c-.46-4.86-1.11-10.08,0-14.89.54-2.39,1.78-5,4.55-5.12C72.73,92.59,74.7,87.92,74.69,87.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.67,81.78,74.76,87.3a2.83,2.83,0,0,1-1.89-3.64A3.07,3.07,0,0,1,76.67,81.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.46,82.5l3.23,4.87a2.83,2.83,0,0,1-4-.7A3.07,3.07,0,0,1,71.46,82.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.51,90.24c2.39,1.45,5.32,7.54,4.91,20.26-.35,10.77-3.87,13.4-5.63,14.15s-5.14.26-8.42-.32l-.06,6.47s4.49,5.32,4.18,8.28-6.6,3.61-10.83.67a27.69,27.69,0,0,1-6.91-7.37l.16-16.76s-1.82,1.89-5-.33a5.87,5.87,0,0,1-1.42-8.54c1.39-1.61,4.92-1.7,6.59.85,0,0,4.42-.35,11.44-4.12A22.54,22.54,0,0,0,105.51,90.24Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2,107.67a1.37,1.37,0,0,1-1.29,1.45,1.41,1.41,0,1,1,1.29-1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.69,116.82l3.14,1A1.62,1.62,0,0,1,99.77,119,1.72,1.72,0,0,1,98.69,116.82Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.26,103.62l-2.73-1.93a1.6,1.6,0,0,1,2.28-.45A1.76,1.76,0,0,1,109.26,103.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.6,106.79a1.36,1.36,0,1,1-1.42-1.35A1.38,1.38,0,0,1,108.6,106.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.08 105.95 101.22 114.11 105.53 112.82 101.08 105.95",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.37,124.33c-3.47-.49-10.58-2.6-11.66-5.43a7.3,7.3,0,0,0,2.46,3.62c2.12,1.84,9.18,4,9.18,4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7,177.7c2.32-8.73,12-27.79,14.79-34.8,3.16-8,8.5-10.78,14.24-10.81,2.09,2.74,2.85,16.42-3.73,24.2-2.82,5.8-11.28,22-11.28,22,.2,1.57,5.81,21.93,8.23,27.3a4.25,4.25,0,0,0,2.17,2.11c2.55,1.14,5.53,4,7.56,5.58,1.58,1.26,2.81,1.45,2.7,1.94a2.31,2.31,0,0,1-2.78,1.44,36.13,36.13,0,0,1-5.06-2.1,62.52,62.52,0,0,0,5,7c3.41,4,3.26,7.41-3.46,7.45-5.08,0-7.72-2.85-12.14-11.59-1.28-2.52-3.22-6.25-4.74-9.48-3.84-8.18-5.74-11.63-7.83-16.86C42.08,182.88,40.81,181.06,41.7,177.7Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.44,178.41,67.74,157A38.73,38.73,0,0,0,73.3,131.9c-6.36-.11-11.06.42-14.77,5.76s-15.78,35-17.07,38.61-1,4.47.2,7.69c2.72,6.59,12,24.86,12,24.86.58-4,5.89-7.36,8.91-6.93Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.44,178.41,67.74,157A38.73,38.73,0,0,0,73.3,131.9c-6.36-.11-11.06.42-14.77,5.76s-15.78,35-17.07,38.61-1,4.47.2,7.69c2.72,6.59,12,24.86,12,24.86.58-4,5.89-7.36,8.91-6.93Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.81,124.84c-1.26.14-2.12.21-2.89,1.49s-3.35,4.93-3.35,4.93-.14,8.59.7,10.83c.73,1.94,4.91,9.85,4.91,9.85s-1,7.58-1.05,10.23,3.51,13,4,18.14c0,0,1.13-12.39,1.54-18.78,1.18-18.12-3.94-28.48-3.94-30.6Z",
    style: {
      fill: "#2F8AE1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.81,124.84c-1.26.14-2.12.21-2.89,1.49s-3.35,4.93-3.35,4.93-.14,8.59.7,10.83c.73,1.94,4.91,9.85,4.91,9.85s-1,7.58-1.05,10.23,3.51,13,4,18.14c0,0,1.13-12.39,1.54-18.78,1.18-18.12-3.94-28.48-3.94-30.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamplePlaceholder);
export default __webpack_public_path__ + "static/media/example-placeholder.4fcab755924a673ab93ec9f3b4c5408a.svg";
export { ForwardRef as ReactComponent };